const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.1/8 is considered localhost for IPv4.
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/),
);

const isStagingServer = Boolean(
  window.location.hostname.match(/d2l9lkx0uhegw0/) || window.location.hostname.match(/staging/),
);

const isSandboxServer = Boolean(
  window.location.hostname.match(/d2l9lkx0uhegw0/) || window.location.hostname.match(/sandbox/),
);

const isCharliesProduceServer = Boolean(
  window.location.hostname.match(/d2l9lkx0uhegw0/) || window.location.hostname.match(/charlies/),
);

const isClientTestServer = isCharliesProduceServer;

const isProd = Boolean(window.location.hostname.match(/fsa-categorizer.cutanddry.com/));

const SERVER = isStagingServer
  ? 'https://fsa-staging-api.eng.cutanddry.com'
  : isSandboxServer
  ? 'https://fsa-sandbox-api.cutanddry.com'
  : isCharliesProduceServer
  ? 'https://fsa-charlies-produce-api.cutanddry.com'
  : isLocalhost
  ? 'http://127.0.0.1:5000'
  : 'https://fsa-categorizer-api.cutanddry.com';

// for now it would be the same servers for task execution too
const TASK_SERVER = isProd
  ? 'https://fsa-categorizer-api.cutanddry.com'
  : isStagingServer
  ? 'https://fsa-staging-api.eng.cutanddry.com'
  : isSandboxServer
  ? 'https://fsa-sandbox-api.cutanddry.com'
  : isCharliesProduceServer
  ? 'https://fsa-charlies-produce-api.cutanddry.com'
  : 'http://127.0.0.1:5000';

const API = SERVER + '/api/v1';
const TASK_API = TASK_SERVER + '/api/v1';

// endpoints for the tasks execution
const DATA_SOURCE_PROCESS = TASK_API + '/data-source/process';

const TASK = TASK_API + '/task';
const DELETE_TASK = TASK + '/:task_id';
const KILL_TASK = TASK + '/kill_process/:task_id';
const EXECUTE_TASK = TASK + '/execute-task';

// endpoints for non tasks
const AUTH = API + '/auth';
const LOGIN = AUTH + '/login';
const LOGOUT = AUTH + '/logout';
const CURRENT_USER = AUTH + '/logged-in-user';
const CURRENT_USER_PING = AUTH + '/ping';

const VIEWS = API + '/views';

const API_INTEGRATION = API + '/api-integration';
const API_INTEGRATION_LIST = API_INTEGRATION + '/list';
const API_INTEGRATION_DELETE = API_INTEGRATION + '/:api_integration_id';

const DATA_SYNC = API + '/data-sync';
const EXPORT_ATTRIBUTES = DATA_SYNC + '/export/attributes';
const IMPORT_ATTRIBUTES = DATA_SYNC + '/import/attributes';
const UPDATE_ATTRIBUTES_BY_ATTRIBUTE_ID = DATA_SYNC + '/update-by-attribute-id/attributes';
const IMPORT_ATTRIBUTE_VALUES = DATA_SYNC + '/import/attribute-values';
const EXPORT_PRODUCTS_CD = DATA_SYNC + '/products/export/cut-dry';
const GTIN_VALIDATOR_CSV = DATA_SYNC + '/gtin_validator';
const GLOBAL_PRODUCTS_MARK_SPECIALLY_UPLOADED =
  DATA_SYNC + '/global-products/mark-specially-uploaded';
const EXPORT_P0_CD = DATA_SYNC + '/export/p0-data/cut-dry';
const UPDATE_SYSCO_STATUSES = DATA_SYNC + '/global-products/update-sysco-statuses';
const EXPORT_DATA_CUT_DRY = DATA_SYNC + '/export/cut-dry';
const FIX_VENDOR_DATA = DATA_SYNC + '/fix-vendor-data';
const FIX_MANUFACTURER_DATA = DATA_SYNC + '/fix-manufacturer-data';
const CLEAN_INVALID_PRODUCTS = DATA_SYNC + '/clean-invalid-products';
const EXPORT_HILLCREST_ERRORS = DATA_SYNC + '/export-hillcrest-errors';
const SEPARATE_HILLCREST_PRODUCTS = DATA_SYNC + '/separate-hillcrest-products';
const DELETE_ORPHANED_GLOBAL_PRODUCTS = DATA_SYNC + '/global-products/delete-orphaned';
const FIX_INVALID_GLOBAL_PRODUCT_NAMES = DATA_SYNC + '/global-products/fix-invalid-names';
const HILLCREST_PRODUCT_RESTORE = DATA_SYNC + '/hillcrest-product-restore';
const ADD_TAXONOMY_FRIENDLY_NAMES = DATA_SYNC + '/taxonomy/add-friendly-names';
const RESET_PRODUCT_THUMBNAILS = DATA_SYNC + '/products/reset-thumbnails';
const FSA_SKU_MAPPINGS_EXPORT = DATA_SYNC + '/export/fsa-sku-mappings';
const ADD_VENDOR_THUMBNAIL_ATTRIBUTE = DATA_SYNC + '/global-attributes/vendor-thumbnail';
const ADD_MANUFACTURER_THUMBNAIL_ATTRIBUTE = DATA_SYNC + '/global-attributes/mfr-thumbnail';
const UPDATE_VENDOR_PRODUCT_SCORES = DATA_SYNC + '/global-product-vendors/update-product-scores';
const UPDATE_MANUFACTURER_PRODUCT_SCORES =
  DATA_SYNC + '/global-product-manufacturers/update-product-scores';
const EXPORT_INCORRECTLY_LINKED_PRODUCTS_LIST = DATA_SYNC + '/export/incorrectly-linked-gtins';

const GLOBAL_PRODUCTS = API + '/global-products';
const GLOBAL_PRODUCTS_DOWNLOAD_CSV = GLOBAL_PRODUCTS + '/download-csv';
const GLOBAL_PRODUCTS_BY_IDS = GLOBAL_PRODUCTS + '/get-by-ids';
const GLOBAL_PRODUCTS_BY_SEARCH = GLOBAL_PRODUCTS + '/search';
const GLOBAL_PRODUCT_SUMMARY = GLOBAL_PRODUCTS + '/summary';
const GLOBAL_PRODUCT_SALES_PRICING = GLOBAL_PRODUCTS + '/sales-pricing';
const GLOBAL_PRODUCT_DISTRIBUTORS = GLOBAL_PRODUCTS + '/distributors';
const GLOBAL_PRODUCTS_UPDATE_CATEGORIES = GLOBAL_PRODUCTS + '/update-categories';
const GLOBAL_PRODUCT_REMOVE_CATEGORIES = GLOBAL_PRODUCTS + '/remove-categories';
const PRODUCTS_BY_GLOBAL_PRODUCT_IDS = GLOBAL_PRODUCTS + '/get-by-global-product-ids';
const GLOBAL_PRODUCTS_WITHOUT_DEFAULT_IMAGES = GLOBAL_PRODUCTS + '/get-without-default-images';

const GLOBAL_PRODUCT_MANUFACTURER = API + '/global-product-manufacturer';
const GLOBAL_PRODUCT_MANUFACTURER_CREATE = GLOBAL_PRODUCT_MANUFACTURER + '/create-from-fsa';
const GLOBAL_PRODUCT_MANUFACTURER_PDP = GLOBAL_PRODUCT_MANUFACTURER + '/pdp/:productId';
const GLOBAL_PRODUCT_MANUFACTURER_UPDATE = GLOBAL_PRODUCT_MANUFACTURER + '/update';

const GLOBAL_PRODUCT_MANUFACTURERS = API + '/global-product-manufacturers';
const GLOBAL_PRODUCT_MANUFACTURERS_BY_SEARCH = GLOBAL_PRODUCT_MANUFACTURERS + '/search';

const OPEN_SEARCH_INDEXES = API + '/open-search-indexes';
const OPEN_SEARCH_INDEX_MFR_PRODUCT_SEARCH = OPEN_SEARCH_INDEXES + '/mfr-products-search';

const GLOBAL_PRODUCT_MANUFACTURERS_L1_CATEGRIES = GLOBAL_PRODUCT_MANUFACTURERS + '/l1-categories';

const GLOBAL_PRODUCT = API + '/global-product/:productId';
const GLOBAL_PRODUCT_PDP = API + '/global-product/pdp';
const GLOBAL_PRODUCT_MERGE_DUPLICATES = GLOBAL_PRODUCT + ':productId/merge-duplicates';
const GLOBAL_PRODUCT_RESET_CACHE = API + '/global-product/reset-cache';
const GLOBAL_PRODUCT_DEFAULT_IMAGE_UPDATE = API + '/global-product/default-image-url/:productId';
const GLOBAL_PRODUCT_ID_UPDATE = API + '/global-product/update-global-product-id';
const GLOBAL_PRODUCT_REJECTED_GTINS = API + '/global-product/rejected-gtins';

const GLOBAL_PRODUCT_VENDOR = API + '/global-product-vendor';
const GLOBAL_PRODUCT_VENDOR_CLONE = GLOBAL_PRODUCT_VENDOR + '/clone';
const GLOBAL_PRODUCT_VENDOR_CLONE_IMAGES = GLOBAL_PRODUCT_VENDOR + '/clone-images';
const GLOBAL_PRODUCT_VENDOR_MARK_AS_DEMO = GLOBAL_PRODUCT_VENDOR + '/mark-as-demo-product';
const GLOBAL_PRODUCT_VENDOR_MANUFACTURER_PRODUCT_LINK_SUGGESTIONS =
  GLOBAL_PRODUCT_VENDOR + '/send-data-to-ml-server-to-get-product-link-suggestions';
const GLOBAL_PRODUCT_VENDOR_LINK_SUGGESTIONS =
  GLOBAL_PRODUCT_VENDOR + '/get-product-link-suggestions';
const GLOBAL_PRODUCT_VENDOR_GET_PRODUCTS = GLOBAL_PRODUCT_VENDOR + '/get-products';

const TEMPORARY_PRODUCT_IMAGE = API + '/temporary-product-image';
const TEMPORARY_PRODUCT_IMAGE_GET_PRODUCTS =
  TEMPORARY_PRODUCT_IMAGE + '/get-products-for-thumbnail-assigning';
const TEMPORARY_PRODUCT_IMAGE_UPDATE_TEMP_IMAGE = TEMPORARY_PRODUCT_IMAGE + '/update-temp-image';
const TEMPORARY_PRODUCT_IMAGE_THUMBNAIL_ASSIGNING_STATS =
  TEMPORARY_PRODUCT_IMAGE + '/get-thumbnail-assigning-stats';
const TEMPORARY_PRODUCT_IMAGE_PREPARE_PRODUCT_LIST_FOR_THUMBNAIL_ASSIGNING =
  TEMPORARY_PRODUCT_IMAGE + '/prepare-product-list-for-thumbnail-assigning';
const TEMPORARY_PRODUCT_IMAGE_SEND_DATA_TO_ML_SERVER_TO_GET_THUMBNAIL_SUGGESTIONS =
  TEMPORARY_PRODUCT_IMAGE + '/send-data-to-ml-server-to-get-thumbnail-suggestions';

const GTIN_VALIDATOR = API + '/gtin_validator';
const GTIN_GS1 = GTIN_VALIDATOR + '/gs1-lookup';

const USER = API + '/user';
const USER_CREATE = USER + '/create';

const USER_NOTIFICATIONS = API + '/user_notifications';
const USER_GET_ALL_NOTIFICATIONS = USER_NOTIFICATIONS + '/get-all-notifications-for-user';

const USERS = API + '/users';
const UPDATE_USER_ROLES = USERS + '/update-roles';
const USERS_OF_REJECTED_DEFAULT_L4_IMAGES = USERS + '/get-users-for-rejected-l4-images';
const USERS_GET_FOR_DROPDOWN = USERS + '/get-for-dropdown';

const USER_TIME_LOG = API + '/user-time-log';
const USER_TIME_LOG_GET_LOGS = USER_TIME_LOG + '/get-logs';
const USER_TIME_LOG_CREATE = USER_TIME_LOG + '/create';
const USER_TIME_LOG_DELETE = USER_TIME_LOG + '/delete/:log_id';
const USER_TIME_LOG_SET_CONFIGURATIONS = USER_TIME_LOG + '/set-configurations';
const USER_TIME_LOG_GET_CONFIGURATIONS = USER_TIME_LOG + '/get-configurations';

const ROLE = API + '/role';
const ROLES = API + '/roles';

const FILE_EXPORTS = API + '/file-exports';
const FILE_EXPORT_PRESIGNED_URL = FILE_EXPORTS + '/:export_id/presigned-url';
const FILE_EXPORTS_GENERATE_REPORTS = FILE_EXPORTS + '/generate-report';
const FILE_EXPORTS_MANUFACTURER_SKU_CLEAN_UP_REPORT =
  FILE_EXPORTS + '/mfr-sku-clean-up-report/:manufacturer_id';
const FILE_EXPORTS_ENGAGED_MANUFACTURER_SCORES_EXPORT =
  FILE_EXPORTS + '/engaged-manufacturer-scores';
const FILE_EXPORTS_MANUFACTURERS_GLN_STATUS_ASSOCIATED_WITH_A_VENDOR =
  FILE_EXPORTS + '/manufacturers-gln-status-associated-with-a-vendor';
const FILE_EXPORTS_PRODUCT_DATA_WITH_GMV_AND_MAPPING =
  FILE_EXPORTS + '/product-data-with-gmv-and-mapping';
const FILE_EXPORTS_MASTER_LOCATION_PRODUCT_DETAILS =
  FILE_EXPORTS + '/master-location-product-details';
const FILE_EXPORTS_UNMAPPED_GMV_PRODUCTS = FILE_EXPORTS + '/unmapped-gmv-products';
const FILE_EXPORTS_UNSTRUCTURED_GMV_PRODUCTS = FILE_EXPORTS + '/unstructured-gmv-products';
const REBATE_ANALYSIS_CSV_UPLOAD = API + '/rebate-analysis/uploads';
const REBATE_ANALYSIS_UPLOADS = API + '/rebate-analysis/uploads';
const REBATE_ANALYSIS_UPLOAD = API + '/rebate-analysis/uploads/:upload_id';
const REBATE_ANALYSIS_UPLOAD_PRESIGNED_URL =
  API + '/rebate-analysis/uploads/:upload_id/presigned-url';
const REBATE_ANALYSIS_UPLOAD_CONTENT = API + '/rebate-analysis/uploads/:upload_id/content';
const REBATE_ANALYSIS_RUN_ANALYSIS = API + '/rebate-analysis/uploads/:upload_id/run-analysis';
const REBATE_ANALYSIS_UPLOAD_FILE = API + '/rebate-analysis/uploads/:upload_id/files/:file_type';

const DEVIATED_PRICE_ANALYSIS_UPLOADS = API + '/po-analysis/uploads';
const DEVIATED_PRICE_ANALYSIS_UPLOAD = API + '/po-analysis/uploads/:upload_id';
const DEVIATED_PRICE_ANALYSIS_GENERATE_REPORT =
  API + '/po-analysis/uploads/:upload_id/generate-report';
const DEVIATED_PRICE_ANALYSIS_UPLOAD_FILE = API + '/po-analysis/uploads/:upload_id/files/report';

const TASKS = API + '/tasks';
const TASKS_COUNT_BY_STATUS = API + '/tasks/count';
const TASKS_ANALYZE_P0_SYNC_GAPS = API + '/tasks/analyze-p0-sync-gaps';

const TAXONOMY = API + '/taxonomy';
const TAXONOMY_CATEGORY_NAMES = TAXONOMY + '/get-categories';
const TAXONOMY_GET = TAXONOMY + '/get-taxonomy';
const TAXONOMY_CREATE_CATEGORY = TAXONOMY + '/create-category';
const TAXONOMY_EDIT_CATEGORY_NAME = TAXONOMY + '/edit-category-name';
const TAXONOMY_EXPORT = TAXONOMY + '/export';
const TAXONOMY_DELETE_CATEGORY = TAXONOMY + '/delete-category/:category_level/:category_id';
const TAXONOMY_CATEGORY_OPTIONS = TAXONOMY + '/get-category-options';
const TAXONOMY_CATEGORY_LEVEL_OPTIONS = TAXONOMY + '/get-category-options/:category_level';
const TAXONOMY_CATEGORY_LEVEL_OPTIONS_WITH_SUB_OPTIONS =
  TAXONOMY + '/get-category-options-with-sub-categories';
const TAXONOMY_CATEGORY_DETAILS = TAXONOMY + '/get-category-details/:category_level/:category_id';
const TAXONOMY_CHILD_CATEGORY_DETAILS = TAXONOMY + '/get-child-category-options';
const TAXONOMY_CATEGORY_OPTIONS_FOR_PRODUCT_LIST =
  TAXONOMY + '/get-category-options-product-list/:product_list_id';
const TAXONOMY_L3_DEFAULT_IMAGE = TAXONOMY + '/get-l3-default-image';
const TAXONOMY_L4_DEFAULT_IMAGE = TAXONOMY + '/get-l4-default-image';
const TAXONOMY_SET_L3_DEFAULT_IMAGE = TAXONOMY + '/set-l3-default-image';
const TAXONOMY_SET_L4_DEFAULT_IMAGE = TAXONOMY + '/set-l4-default-image';
const TAXONOMY_SET_L3_DEFAULT_IMAGE_NOT_APPLICABLE =
  TAXONOMY + '/set-l3-default-image-not-applicable';
const TAXONOMY_SET_L4_DEFAULT_IMAGE_NOT_APPLICABLE =
  TAXONOMY + '/set-l4-default-image-not-applicable';
const TAXONOMY_GET_L4_CATEGORIES_BY_IMAGE_UPLOAD_STATUS = TAXONOMY + '/l3/get-l4-default-images';
const TAXONOMY_GET_L3_CATEGORIES_BY_L4_IMAGE_UPLOAD_STATUS =
  TAXONOMY + '/l3-by-l4-default-image-status';
const TAXONOMY_GET_REJECTED_L4_IMAGES_BY_USER_ID =
  TAXONOMY + '/user/get-rejected-l4-default-images';
const TAXONOMY_REVIEW_L4_DEFAULT_IMAGES = TAXONOMY + '/review-l4-default-images';
const TAXONOMY_UPB_VIEW_CATEGORY_OPTIONS = TAXONOMY + '/get-upb-view-l1-category-options';
const TAXONOMY_UPPER_LEVELS = TAXONOMY + '/get-upper-levels';

const L4_CATEGORY_DIVISION = API + '/l4-category-division';
const L4_CATEGORY_DIVISION_AVAILABLE_CATEGORIES = L4_CATEGORY_DIVISION + '/available-categories';
const L4_CATEGORY_DIVISION_ATTRIBUTE_SUMMARY = L4_CATEGORY_DIVISION + '/attribute-summary';
const L4_CATEGORY_DIVISION_PRODUCTS_BY_ATTRIBUTE = L4_CATEGORY_DIVISION + '/products-by-attribute';
const L4_CATEGORY_DIVISION_SEND_PRODUCTS = L4_CATEGORY_DIVISION + '/send-products-for-division';
const L4_CATEGORY_DIVISION_LARGE_CATEGORIES = L4_CATEGORY_DIVISION + '/large-categories';
const L4_CATEGORY_DIVISION_EXPORT_LARGE_CATEGORIES =
  L4_CATEGORY_DIVISION + '/export-large-categories';
const L4_CATEGORY_DIVISION_EXPORT_CATEGORY_PRODUCTS =
  L4_CATEGORY_DIVISION + '/export-category-products';
const L4_CATEGORY_DIVISION_EXPORT_RESEGMENTATION_VIEW =
  L4_CATEGORY_DIVISION + '/export-resegmentation-view';
const L4_CATEGORY_DIVISION_EXPORT_RESEGMENTATION_ERROR_REPORT =
  L4_CATEGORY_DIVISION + '/export-resegmentation-error-report';
const L4_CATEGORY_DIVISION_EXPORT_SEGMENTATION_VIEW =
  L4_CATEGORY_DIVISION + '/export-segmentation-view';
const L4_CATEGORY_DIVISION_RESEGMENT_BY_ATTRIBUTE =
  L4_CATEGORY_DIVISION + '/resegment-by-attribute';
const L4_CATEGORY_DIVISION_RETRY_SEGMENTATION = L4_CATEGORY_DIVISION + '/retry-segmentation';
const L4_CATEGORY_DIVISION_RESEGMENTED_CATEGORIES =
  L4_CATEGORY_DIVISION + '/resegmented-categories';
const L4_CATEGORY_DIVISION_RESEGMENTED_PRODUCTS = L4_CATEGORY_DIVISION + '/resegmented-products';
const L4_CATEGORY_DIVISION_RESEGMENTED_FILTER_OPTIONS =
  L4_CATEGORY_DIVISION + '/resegmented-filter-options';
const L4_CATEGORY_DIVISION_RESEGMENTED_CLASSIFICATION_OPTIONS =
  L4_CATEGORY_DIVISION + '/resegmented-classification-options';
const L4_CATEGORY_DIVISION_RESEGMENTED_CLUSTER_NAMES =
  L4_CATEGORY_DIVISION + '/resegmented-cluster-names';
const L4_CATEGORY_DIVISION_RESEGMENTED_MOVE_CLUSTER =
  L4_CATEGORY_DIVISION + '/resegmented-products/move-cluster';
const L4_CATEGORY_DIVISION_RESEGMENTED_REMOVE_PRODUCT =
  L4_CATEGORY_DIVISION + '/resegmented-products/remove';
const L4_CATEGORY_DIVISION_RESEGMENTED_CLASSIFY =
  L4_CATEGORY_DIVISION + '/resegmented-products/classify';
const L4_CATEGORY_DIVISION_RESEGMENTED_BULK_MOVE_CLUSTER =
  L4_CATEGORY_DIVISION + '/resegmented-products/bulk-move-cluster';
const L4_CATEGORY_DIVISION_RESEGMENTED_BULK_REMOVE =
  L4_CATEGORY_DIVISION + '/resegmented-products/bulk-remove';
const L4_CATEGORY_DIVISION_RESEGMENTED_RENAME_CLUSTER =
  L4_CATEGORY_DIVISION + '/resegmented-products/rename-cluster';

const ACTIVITY_LOGS = API + '/activity-logs';
const ACTIVITY_LOGS_FIND = ACTIVITY_LOGS + '/find';

const ATTRIBUTE = API + '/attribute';
const ATTRIBUTE_DELETE = ATTRIBUTE + '/:attribute_id';
const ATTRIBUTE_MIGRATE_TO_GLOBAL_ATTRIBUTE = ATTRIBUTE + '/migrate-to-global-attribute';
const ATTRIBUTE_MERGE = ATTRIBUTE + '/merge-attributes';

const ATTRIBUTE_SCORE = API + '/attribute-score';
const ATTRIBUTE_SCORE_GROUP_BY_SECTION = ATTRIBUTE_SCORE + '/group-by-section';
const ATTRIBUTE_SCORE_USER_INPUT_COUNTS = ATTRIBUTE_SCORE + '/user-input-counts';

const ATTRIBUTE_SCORES = API + '/attribute-scores';
const ATTRIBUTE_SCORES_GROUP_BY_SECTION = ATTRIBUTE_SCORES + '/group-by-section';

const ATTRIBUTE_SUB_SECTION_SCORES = API + '/attribute-sub-section-scores';
const ATTRIBUTE_SUB_SECTION_SCORES_UPDATE = ATTRIBUTE_SUB_SECTION_SCORES + '/update';
const ATTRIBUTE_SUB_SECTION_SCORES_GROUP_BY_SECTION =
  ATTRIBUTE_SUB_SECTION_SCORES + '/group-by-section';

const ATTRIBUTES = API + '/attributes';
const ALL_ATTRIBUTES = ATTRIBUTES + '/all';
const ATTRIBUTES_FOR_DATA_SOURCE_MAPPING = ATTRIBUTES + '/for-data-source-mapping';
const ATTRIBUTES_BY_CATEGORY_LEVEL = ATTRIBUTES + '/search-by-category-level';
const ATTRIBUTES_FOR_CATEGORY_LEVEL = ATTRIBUTES + '/search-by-category';
const ATTRIBUTES_FOR_CATEGORY_LEVEL_FOR_MULTI_CATEGORIES = ATTRIBUTES + '/search-by-multi-category';
const ATTRIBUTES_ASSIGNED_CATEGORIES = ATTRIBUTES + '/assigned-categories';
const ATTRIBUTES_FOR_PRODUCT = ATTRIBUTES + '/get-for-product';
const ATTRIBUTES_FOR_PRODUCT_UPDATE = ATTRIBUTES + '/update-for-product';
const ATTRIBUTES_FOR_PRODUCT_UPDATE_MULTI = ATTRIBUTES + '/multi-update-for-product';
const ATTRIBUTE_CSV_IMPORT_FOR_ROSETTA_TAXONOMIES = ATTRIBUTES + '/taxonomy/import-csv';
const ATTRIBUTION_COMPLIANCE_CSV_EXPORT = ATTRIBUTES + '/file/priority-compliance';
const ATTRIBUTES_COUNT_BY_SECTION = ATTRIBUTES + '/count-by-section';

const ATTRIBUTE_VALUE = API + '/attribute-value';
const ATTRIBUTE_VALUE_MERGE = ATTRIBUTE_VALUE + '/merge-attribute-value';
const ATTRIBUTE_VALUE_DETAILS = ATTRIBUTE_VALUE + '/:attribute_value_id';
const ATTRIBUTE_VALUES = API + '/attribute-values';
const ATTRIBUTE_VALUES_BY_ATTRIBUTE_NAME = ATTRIBUTE_VALUES + '/by-attribute-name';
const GET_DISPLAY_VALUE_ENABLED_RECORDS = ATTRIBUTE_VALUES + '/display-values';
const ADD_DISPLAY_VALUE = ATTRIBUTE_VALUES + '/add-display-values';

const ATTRIBUTE_VALUE_MAP = API + '/attribute-value-map';
const ATTRIBUTE_VALUE_MAPS = API + '/attribute-value-maps';

const ATTRIBUTE_VALUE_GROUP_MAP = API + '/attribute-value-group-map';
const ATTRIBUTE_VALUE_GROUP_MAPS_BY_ATTRIBUTE_ID = ATTRIBUTE_VALUE_GROUP_MAP + '/attribute';

const ATTRIBUTE_VALUE_GROUP_MAPS = API + '/attribute-value-group-maps';

const GLOBAL_ATTRIBUTE = API + '/global-attribute';
const GLOBAL_ATTRIBUTE_MIGRATE_TO_ATTRIBUTE = GLOBAL_ATTRIBUTE + '/migrate-to-attribute';
const GLOBAL_ATTRIBUTE_DETAILS = GLOBAL_ATTRIBUTE + '/:global_attribute_id';
const GLOBAL_ATTRIBUTE_DELETE = GLOBAL_ATTRIBUTE + '/:global_attribute_id';

const GLOBAL_ATTRIBUTES = API + '/global-attributes';
const GLOBAL_ATTRIBUTES_FOR_SECTION = GLOBAL_ATTRIBUTES + '/attribute-section';

const GLOBAL_VENDOR_ATTRIBUTE_REQUIREMENTS = API + '/global-vendor-attribute-requirements';
const GLOBAL_VENDOR_ATTRIBUTE_REQUIREMENTS_FOR_ATTRIBUTE =
  GLOBAL_VENDOR_ATTRIBUTE_REQUIREMENTS + '/:attribute_id';

const ATTRIBUTES_MAP = API + '/attributes_map';
const ATTRIBUTES_MAP_DETAILS = ATTRIBUTES_MAP + '/:attribute_map_id';

const ATTRIBUTES_MAPS = API + '/attributes_maps';
const ATTRIBUTES_MAPS_CREATE = ATTRIBUTES_MAPS + '/add';
const ATTRIBUTES_MAPS_MULTI_CREATE = ATTRIBUTES_MAPS + '/add-multi';
const ATTRIBUTES_MAPS_DETAILS = ATTRIBUTES_MAPS + '/:attribute_map_ids';

const ATTRIBUTES_SECTION = API + '/attribute-section';
const ATTRIBUTES_SUB_SECTIONS_FOR_SECTION =
  ATTRIBUTES_SECTION + '/:attribute_section_id/sub_sections';
const ATTRIBUTES_SECTIONS = API + '/attribute-sections';

const ATTRIBUTES_SUB_SECTION = API + '/attribute-sub-section';
const ATTRIBUTES_SUB_SECTION_ALL = ATTRIBUTES_SUB_SECTION + '/all';
const ATTRIBUTES_SUB_SECTIONS_WITH_SECTIONS = ATTRIBUTES_SUB_SECTION + '/all/with-sections';
const ATTRIBUTES_SUB_SECTIONS_FOR_A_SECTION =
  ATTRIBUTES_SUB_SECTION + '/:attribute_sub_section_id/id';

const BRAND = API + '/brand';
const BRAND_HARVEST = BRAND + '/harvest';
const SIMILAR_BRAND_INFO = BRAND + '/get-similar-brand-name-info';
const SIMILAR_BRAND_UPDATE = BRAND + '/update-similar-brand-name-info';
const GET_SIMILAR_BRAND_NAME_INFO = BRAND + '/get-similar-brand-name-info-v2';
const UPDATE_SIMILAR_BRAND = BRAND + '/update-similar-brand-name-info';
const UPDATE_SIMILAR_BRAND_DISPLAY_STATUS = BRAND + '/update-display-status';

const BRANDS = API + '/brands';
const BRANDS_HARVEST = BRANDS + '/harvest';
const BRANDS_FOR_HARVEST = BRANDS + '/harvest';
const BRANDS_FOR_QA = BRANDS + '/for-QA';
const BRANDS_FOR_HARVEST_GROUPED = BRANDS + '/harvest-group-by-domain';
const BRANDS_BY_IDS = BRANDS + '/get-by-ids';
const BRANDS_GET_BY_ID = BRANDS + '/:brand_id';
const BRANDS_GET_BY_NAME = BRANDS + '/by-name/:brand_name';
const BRANDS_GET_BY_MANUFACTURER = BRANDS + '/manufacturer-brands';
const BRANDS_GENERATE_ACTIVITY_REPORT = BRANDS + '/brands-generate-activity-report';
const BRANDS_CREATE = BRANDS + '/create';
const BRANDS_UPDATE = BRANDS + '/update';
const BRANDS_UPDATE_MULTI = BRANDS + '/update-brands';
const BRANDS_UPDATE_FROM_FSA = BRANDS + '/update-from-fsa';
const BRANDS_UPDATE_FROM_QA = BRANDS + '/update-from-qa';
const BRANDS_MERGE = BRANDS + '/merge';
const BRANDS_DELETE = BRANDS + '/delete';
const BRANDS_DELETE_LOGO = BRANDS + '/delete-logo/:brand_id';
const BRANDS_FOR_DROPDOWN = BRANDS + '/get-for-dropdown';
const BRANDS_IMPORT = BRANDS + '/import-brands';
const BRANDS_DELETE_UNLINKED = BRANDS + '/delete-unlinked-brands';
const BRANDS_UNVERIFY = BRANDS + '/unverify-brands';
const BRANDS_DOWNLOAD_CSV = BRANDS + '/download-csv';
const BRANDS_ACTIVITY_LOG = BRANDS + '/activity-log';
const BRANDS_DELETE_SIMILAR_BRAND_NAMES = BRANDS + '/similar-brand-names/:similar_brand_name_ids';
const BRANDS_PRODUCTS = BRANDS + '/products';
const BRAND_PRODUCT_OUTLIER_CLEANUP_STATS = BRANDS + '/brand-product-outlier-cleanup-stats';
const BRANDS_DP_PRODUCTS = BRANDS + '/get-dp-products-for-brand';
const BRAND_CATEGORY_FILTER_OPTIONS = BRANDS + '/category-filter-options';
const FOR_CONTENT_QA = BRANDS + '/get-for-content-qa';
const UPDATE_PRODUCT_BRANDS = BRANDS + '/update-product-brands';
const SEND_DATA_TO_ML_SERVER_TO_NORMALIZE_DP_BRANDS =
  BRANDS + '/export-dp-brands-for-normalization';
const SEND_DATA_TO_ML_SERVER_TO_EXTRACT_BRANDS = BRANDS + '/export-data-for-brand-extraction';

const BRAND_CLEANUP = API + '/brand-cleanup';
const BRAND_CLEANUP_PRODUCTS_EXPORT = BRAND_CLEANUP + '/export-products-for-brand-cleanup';
const GET_FOR_BRAND_CLEANUP = BRAND_CLEANUP + '/get-for-brand-cleanup';
const GET_BRANDS_FOR_BRAND_CLEANUP = BRAND_CLEANUP + '/get-brands-for-brands-cleanup';
const GET_L4_CATEGORIES_FOR_SELECTED_VENDOR_AND_BRAND =
  BRAND_CLEANUP + '/get-l4-categories-for-selected-vendor-and-brand';
const GET_CATEGORIES_FOR_BRAND_CLEANUP = BRAND_CLEANUP + '/get-categories-for-brand-cleanup';
const CLEANUP_BRANDS_OF_SELECTED_PRODUCTS = BRAND_CLEANUP + '/cleanup-brands-of-selected-products';
const GET_SUGGESTED_BRANDS_FOR_BRAND_CLEANUP =
  BRAND_CLEANUP + '/get-suggested-brands-for-brand-cleanup';
const GET_DISTRIBUTOR_BRAND_NAMES_FOR_BRAND_CLEANUP =
  BRAND_CLEANUP + '/get-distributor-brand-names-for-brand-cleanup';

const DUPLICATE_BRANDS = API + '/duplicate-brands';
const DUPLICATE_BRANDS_GET_DUPLICATE_BRAND_CLUSTERS =
  DUPLICATE_BRANDS + '/get-duplicate-brand-clusters';
const DUPLICATE_BRANDS_HANDLE_DUPLICATE_BRAND_CLUSTERS =
  DUPLICATE_BRANDS + '/handle-duplicate-brand-clusters';

const DUPLICATE_UNVERIFIED_BRANDS = API + '/duplicate-unverified-brands';
const DUPLICATE_UNVERIFIED_BRANDS_GET_DUPLICATE_UNVERIFIED_BRAND_CLUSTERS =
  DUPLICATE_UNVERIFIED_BRANDS + '/get-unverified-duplicate-brand-clusters';
const DUPLICATE_UNVERIFIED_BRANDS_HANDLE_DUPLICATE_BRAND_CLUSTERS =
  DUPLICATE_UNVERIFIED_BRANDS + '/handle-unverified-duplicate-brand-clusters';

const BRAND_VERIFICATION_SUGGESTIONS = API + '/brand-verification-suggestions';
const GET_ONE_BRAND_VERIFICATION_SUGGESTION =
  BRAND_VERIFICATION_SUGGESTIONS + '/get-one-brand-verification-suggestion';
const UPDATE_VERIFICATION_STATUS_FROM_SUGGESTION =
  BRAND_VERIFICATION_SUGGESTIONS + '/update-verification-status-from-suggestion';
const UPDATE_BRAND_AND_MANUFACTURER_DATA_FROM_BRAND_VERIFICATION_TOOL =
  BRAND_VERIFICATION_SUGGESTIONS +
  '/update-brand-and-manufacturer-data-from-brand-verification-tool';
const UPDATE_BRAND_VERIFICATION_SUGGESTION = BRAND_VERIFICATION_SUGGESTIONS + '/update';
const BRAND_VERIFICATION_SUGGESTIONS_GET_STATS = BRAND_VERIFICATION_SUGGESTIONS + '/get-stats';

const CHANGE_LOGS = API + '/change-logs';
const CHANGE_LOGS_LATEST_RECORD = CHANGE_LOGS + '/latest-record';
const CHANGE_LOGS_BY_STATUS = CHANGE_LOGS + '/by-status';
const CHANGE_LOGS_BY_REQUEST_ID = CHANGE_LOGS + '/by-request-id';
const CHANGE_LOGS_BY_IDS = CHANGE_LOGS + '/get-by-ids';
const CHANGE_LOGS_FOR_GLOBAL_PRODUCT = CHANGE_LOGS + '/for-global-product';
const CHANGE_LOGS_UPDATE_STATUS = CHANGE_LOGS + '/update-status';
const CHANGE_LOG_GROUP = CHANGE_LOGS + '/change-log-group';
const CHANGE_LOGS_DELETED_IMAGE_DETAILS = CHANGE_LOGS + '/deleted-image-details';

const CATALOG_FILTER_ATTRIBUTES = API + '/catalog-filter-attributes';
const CATALOG_FILTER_ATTRIBUTES_VENDOR = CATALOG_FILTER_ATTRIBUTES + '/get-by-global-vendor-id';
const CATALOG_FILTER_ATTRIBUTES_VENDOR_CREATE = CATALOG_FILTER_ATTRIBUTES + '/create-new-filter';
const CATALOG_FILTER_ATTRIBUTES_VENDOR_UPDATE = CATALOG_FILTER_ATTRIBUTES + '/update-filter';
const CATALOG_FILTER_ATTRIBUTES_VENDOR_DELETE = CATALOG_FILTER_ATTRIBUTES + '/delete-filter';
const CATALOG_FILTER_ATTRIBUTES_VENDOR_CREATE_PRESET =
  CATALOG_FILTER_ATTRIBUTES + '/create-preset-from-filter';
const CATALOG_FILTER_PRESETS_FOR_DROPDOWN = CATALOG_FILTER_ATTRIBUTES + '/get-presets-for-dropdown';
const CATALOG_FILTER_PRESET = CATALOG_FILTER_ATTRIBUTES + '/get-preset';

const PRODUCT_LIST_SINGLE = API + '/product-list';
const PRODUCT_LIST_ID = PRODUCT_LIST_SINGLE + '/:product_list_id';

const PRODUCT_LISTS = API + '/product-lists';
const ALL_PRODUCT_LISTS = PRODUCT_LISTS + '/all';
const PRODUCT_LIST_IMAGE_FOR_TAGGING = PRODUCT_LISTS + '/images-for-tagging/:product_list_id';
const PRODUCT_LIST = PRODUCT_LISTS + '/:product_list_id';
const PRODUCT_LIST_PRODUCTS = PRODUCT_LIST + '/products';
const PRODUCT_LIST_PRODUCTS_COVERAGE_METRICS = PRODUCT_LISTS + '/re-calculate-coverage-metrics';
const PRODUCT_LIST_BROKEN_IMAGE_DELETE =
  PRODUCT_LISTS + '/remove-broken-image-urls/:product_list_id';
const PRODUCT_LIST_ASSIGN_THUMBNAILS = PRODUCT_LISTS + '/assign-thumbnails';
const PRODUCT_LIST_UPDATE_PRODUCTS = PRODUCT_LISTS + '/update-products';
const PRODUCT_LIST_VENDOR_CATEGORIES =
  PRODUCT_LISTS + '/get-vendor-categories-for-dropdown/:product_list_id';
const PRODUCT_LIST_UPB_MATCH_CSV_EXPORT = PRODUCT_LISTS + '/file/upb_matches';
const PRODUCT_LIST_ATTRIBUTION_CSV_EXPORT = PRODUCT_LISTS + '/file/attribute_export';
const PRODUCT_LIST_ATTRIBUTION_EXPORT = PRODUCT_LISTS + '/file/csv_attribute_export';
const PRODUCT_LIST_IMAGE_SOURCE_EXPORT = PRODUCT_LISTS + '/file/csv_image_source_export';
const PRODUCT_LIST_MANUFACTURER_PRODUCT_ENRICHMENT_EXPORT =
  PRODUCT_LISTS + '/file/manufacturer-product-enrichment-export';
const PRODUCT_LIST_STATUS_UPDATE_ON_PRODUCTS = PRODUCT_LISTS + '/product-status-update';
const PRODUCT_LIST_IMAGE_CLEANUP = PRODUCT_LISTS + '/image-cleanup';
const PRODUCT_LIST_REFRESH_CACHE = PRODUCT_LISTS + '/cache-reset/:product_list_id';
const PRODUCT_LIST_PRODUCT_SCORE = PRODUCT_LISTS + '/product-score/:product_list_id';
const PRODUCT_LIST_PRODUCT_P0_SCORE = PRODUCT_LISTS + '/product-p0-score/:product_list_id';
const PRODUCT_LIST_FOR_DROPDOWNS = PRODUCT_LISTS + '/get-for-dropdowns';
const PRODUCT_LIST_UNASSIGNED_ATTRIBUTES = PRODUCT_LISTS + '/file/export-unassigned-attributes';

// Catalog Import Workflow
const CATALOG_IMPORT_WORKFLOW = API + '/catalog-import-workflow';
const CATALOG_IMPORT_WORKFLOW_STEPS = CATALOG_IMPORT_WORKFLOW + '/steps';
const CATALOG_IMPORT_WORKFLOW_INITIALIZE = CATALOG_IMPORT_WORKFLOW + '/initialize';
const CATALOG_IMPORT_WORKFLOW_START = CATALOG_IMPORT_WORKFLOW + '/start';
const CATALOG_IMPORT_WORKFLOW_STATUS = CATALOG_IMPORT_WORKFLOW + '/status';
const CATALOG_IMPORT_WORKFLOW_RESET = CATALOG_IMPORT_WORKFLOW + '/reset';
const CATALOG_IMPORT_WORKFLOW_MARK_COMPLETE = CATALOG_IMPORT_WORKFLOW + '/steps/mark-complete';
const CATALOG_IMPORT_WORKFLOW_RETRY_STEP = CATALOG_IMPORT_WORKFLOW + '/steps/retry';

const CLIENT_DISTRIBUTOR_PRODUCT = API + '/client-distributor-product';
const CLIENT_DISTRIBUTOR_PRODUCT_NATIONAL_SKU = CLIENT_DISTRIBUTOR_PRODUCT + '/national-sku';
const CLIENT_DISTRIBUTOR_PRODUCT_ATTRIBUTE_PROPAGATION_FLAG =
  CLIENT_DISTRIBUTOR_PRODUCT + '/attribute-propagation-flag';

const CLIENT_MANUFACTURER_PRODUCT = API + '/client-manufacturer-product';
const CLIENT_MANUFACTURER_PRODUCT_UNIPRO_UPB_ELIGIBLE =
  CLIENT_MANUFACTURER_PRODUCT + '/unipro-upb-eligible';

const SKU_MAPPING_WORKFLOW = API + '/sku-mapping-workflow';
const SKU_MAPPING_WORKFLOW_RETRY = SKU_MAPPING_WORKFLOW + '/retry';
const SKU_MAPPING_WORKFLOW_SIMILARITY_THRESHOLD = SKU_MAPPING_WORKFLOW + '/similarity-threshold';

const BRAND_SKU_MAPPER = API + '/brand-sku-mapper';
const BRAND_SKU_MAPPER_MANUFACTURERS = BRAND_SKU_MAPPER + '/manufacturers';
const BRAND_SKU_MAPPER_MANUFACTURER = BRAND_SKU_MAPPER + '/manufacturers/:manufacturer_id';
const BRAND_SKU_MAPPER_START_RUN = BRAND_SKU_MAPPER + '/manufacturers/:manufacturer_id/runs';
const BRAND_SKU_MAPPER_PRODUCTS = BRAND_SKU_MAPPER + '/products';
const BRAND_SKU_MAPPER_REVIEW_CANDIDATE = BRAND_SKU_MAPPER + '/candidates/:candidate_id/review';
const BRAND_SKU_MAPPER_ALL_BRANDS_START = BRAND_SKU_MAPPER + '/all-brands-runs';
const BRAND_SKU_MAPPER_AUTO_APPROVE_GTIN = BRAND_SKU_MAPPER + '/runs/:run_id/auto-approve-gtin';

// Brand SKU Mapper V2 (Stage-1 Pinecone scorer — candidates stored in the DB)
const BRAND_SKU_MAPPER_V2 = API + '/brand-sku-mapper-v2';
const BRAND_SKU_MAPPER_V2_START_RUN = BRAND_SKU_MAPPER_V2 + '/runs';
const BRAND_SKU_MAPPER_V2_ELIGIBLE_COUNTS = BRAND_SKU_MAPPER_V2 + '/runs/eligible-counts';
const BRAND_SKU_MAPPER_V2_FILTER_OPTIONS = BRAND_SKU_MAPPER_V2 + '/runs/filter-options';
const BRAND_SKU_MAPPER_V2_PRODUCTS = BRAND_SKU_MAPPER_V2 + '/products';
const BRAND_SKU_MAPPER_V2_PRODUCT_CANDIDATES =
  BRAND_SKU_MAPPER_V2 + '/products/:global_product_vendor_id/candidates';
const BRAND_SKU_MAPPER_V2_REVIEW_CANDIDATE =
  BRAND_SKU_MAPPER_V2 + '/candidates/:candidate_id/review';

const GLOBAL_VENDOR = API + '/global-vendor';
const GLOBAL_VENDOR_BRAND_COVERAGE = GLOBAL_VENDOR + '/brand-coverage';
const GLOBAL_VENDOR_UPDATE_FLAGS = GLOBAL_VENDOR + '/update-flags';
const GLOBAL_VENDOR_UPDATE_ATTRIBUTE_PROPAGATION_FLAG =
  GLOBAL_VENDOR + '/update-attribute-propagation-flags';
const GLOBAL_VENDOR_MANUFACTURER_PORTAL_REQUESTS = GLOBAL_VENDOR + '/manufacturer-portal-requests';
const GLOBAL_VENDOR_MANUFACTURER_PORTAL_CREATE = GLOBAL_VENDOR + '/create-manufacturer-portals';
const GLOBAL_VENDOR_MANUFACTURER_PORTAL_CREATE_REQUEST =
  GLOBAL_VENDOR + '/manufacturer-portals/:request_id';
const GLOBAL_VENDOR_MANUFACTURER_PORTAL_PRODUCT_EXPORT =
  GLOBAL_VENDOR + '/manufacturer-portal-product-export';
const GLOBAL_VENDOR_MANUFACTURER_PRODUCT_CREATION = GLOBAL_VENDOR + '/create-manufacturer-products';
const GLOBAL_VENDOR_THIRD_PARTY_OPTIONS = GLOBAL_VENDOR + '/third-party-options';
const GLOBAL_VENDOR_SNOWFLAKE_STATS = GLOBAL_VENDOR + '/snowflake-stats';

const CLIENT_GLOBAL_VENDOR = API + '/client-global-vendor';

const GLOBAL_VENDORS = API + '/global-vendors';
const GLOBAL_VENDORS_ASSIGN_THUMBNAILS = GLOBAL_VENDORS + '/assign-thumbnails/:vendor_id';
const GLOBAL_VENDORS_BROKEN_IMAGE_DELETE = GLOBAL_VENDORS + '/remove-broken-image-urls';
const GLOBAL_VENDORS_CREATE_DEMO_CATALOG = GLOBAL_VENDORS + '/create-demo-catalog';
const GLOBAL_VENDORS_GET_BY_ID = GLOBAL_VENDORS + '/:vendor_id';
const GLOBAL_VENDORS_BY_IDS = GLOBAL_VENDORS + '/get-by-ids';
const GLOBAL_VENDORS_FOR_DROPDOWN = GLOBAL_VENDORS + '/get-for-dropdown';
const GLOBAL_VENDORS_UPDATE = GLOBAL_VENDORS + '/update';
const GLOBAL_VENDORS_CREATE = GLOBAL_VENDORS + '/create';
const GLOBAL_VENDORS_DOWNLOAD_CSV = GLOBAL_VENDORS + '/download-csv';
const GLOBAL_VENDORS_DOWNLOAD_STATS_CSV = GLOBAL_VENDORS + '/download-stats-csv';
const GLOBAL_VENDORS_CHAIN_LOCATIONS = GLOBAL_VENDORS + '/:vendor_id/chain-locations';

const GLOBAL_MANUFACTURERS = API + '/global-manufacturers';
const GLOBAL_MANUFACTURERS_CREATE = GLOBAL_MANUFACTURERS + '/create';
const GLOBAL_MANUFACTURERS_GET_BY_ID = GLOBAL_MANUFACTURERS + '/:manufacturer_id';
const GLOBAL_MANUFACTURERS_BY_IDS = GLOBAL_MANUFACTURERS + '/get-by-ids';
const GLOBAL_MANUFACTURERS_FOR_DROPDOWN = GLOBAL_MANUFACTURERS + '/get-for-dropdown';
const GLOBAL_MANUFACTURERS_UPDATE = GLOBAL_MANUFACTURERS + '/update';
const GLOBAL_MANUFACTURERS_MERGE = GLOBAL_MANUFACTURERS + '/merge';
const GLOBAL_MANUFACTURERS_ASSIGN_THUMBNAILS =
  GLOBAL_MANUFACTURERS + '/assign-thumbnails/:manufacturer_id';
const GLOBAL_MANUFACTURERS_BROKEN_IMAGE_DELETE =
  GLOBAL_MANUFACTURERS + '/remove-broken-image-urls/:manufacturer_id';
const GLOBAL_MANUFACTURERS_DELETE_UNLINKED =
  GLOBAL_MANUFACTURERS + '/delete-unlinked-manufacturers';
const GLOBAL_MANUFACTURERS_UNVERIFY = GLOBAL_MANUFACTURERS + '/unverify-manufacturers';
const GLOBAL_MANUFACTURERS_DOWNLOAD_CSV = GLOBAL_MANUFACTURERS + '/download-csv';
const GLOBAL_MANUFACTURERS_UPDATE_FROM_FSA = GLOBAL_MANUFACTURERS + '/update-from-fsa';
const GLOBAL_MANUFACTURERS_CONVERT_TO_DISTRIBUTOR =
  GLOBAL_MANUFACTURERS + '/convert-to-distributor/:manufacturer_id';
const GLOBAL_MANUFACTURERS_ACTIVITY_LOG = GLOBAL_MANUFACTURERS + '/activity-log';
const GLOBAL_MANUFACTURERS_DELETE_SIMILAR_MANUFACTURERS_NAMES =
  GLOBAL_MANUFACTURERS + '/similar-manufacturer-names/:similar_manufacturer_name_ids';
const GLOBAL_MANUFACTURERS_PRODUCTS = GLOBAL_MANUFACTURERS + '/products';
const GLOBAL_MANUFACTURERS_GDSN_SUBSCRIPTION =
  GLOBAL_MANUFACTURERS + '/send-gdsn-subscription-message/:manufacturer_id';
const GLOBAL_MANUFACTURERS_EXPORT_BRAND_PRODUCTS =
  GLOBAL_MANUFACTURERS + '/export-products-by-brand/:manufacturer_id';

const GLOBAL_MANUFACTURER = API + '/global-manufacturer';
const GLOBAL_MANUFACTURER_PRODUCT_CREATION = GLOBAL_MANUFACTURER + '/create-manufacturer-products';
const GLOBAL_MANUFACTURER_UPB_SKU = GLOBAL_MANUFACTURER + '/upb-sku';
const GLOBAL_MANUFACTURER_CREATE_PRODUCTS = `${GLOBAL_MANUFACTURER}/create-manufacturer-products`;
const GLOBAL_MANUFACTURER_CREATE_CUT_DRY_PORTAL = `${GLOBAL_MANUFACTURER}/create-cut-dry-portal`;

const GLOBAL_MANUFACTURERS_HARVEST = API + '/global-manufacturer-harvests';
const GLOBAL_MANUFACTURER_HARVEST_STATUS = harvestId =>
  `${GLOBAL_MANUFACTURERS_HARVEST}/${harvestId}/status`;
const GLOBAL_MANUFACTURER_HARVEST_TAGS = harvestId =>
  `${GLOBAL_MANUFACTURERS_HARVEST}/${harvestId}/tags`;
const GLOBAL_MANUFACTURER_HARVEST_TAGS_BY_MANUFACTURER = manufacturerId =>
  `${GLOBAL_MANUFACTURERS_HARVEST}/manufacturer/${manufacturerId}/tags`;
const GLOBAL_MANUFACTURER_HARVEST_STATISTICS = `${GLOBAL_MANUFACTURERS_HARVEST}/statistics`;
const GLOBAL_MANUFACTURER_HARVEST_EXPORT = `${GLOBAL_MANUFACTURERS_HARVEST}/export`;

const CLIENT_GLOBAL_MANUFACTURER = API + '/client-global-manufacturer';

const DASHBOARD = API + '/dashboard';

const DATA_SOURCE = API + '/data-source';
const DATA_SOURCE_ALL = DATA_SOURCE + '/all';
const DATA_SOURCE_ARCHIVE = DATA_SOURCE + '/archive';
const DATA_SOURCE_CLONE = DATA_SOURCE + '/clone';
const DATA_SOURCE_ASSIGN_SKUS = DATA_SOURCE + '/assign-upb-skus';
const DATA_SOURCE_CONNECTED_MANUFACTURERS = DATA_SOURCE + '/connected-manufacturers';
const DATA_SOURCE_CONNECTED_PRODUCTS = DATA_SOURCE + '/connected-products';
const DATA_SOURCE_EXPORT_GDSN_MANUFACTURER_PRODUCTS =
  DATA_SOURCE + '/export-gdsn-manufacturer-products';
const DATA_SOURCE_SEND_GDSN_MANUFACTURER_PRODUCTS_TO_CND =
  DATA_SOURCE + '/send-gdsn-manufacturer-products-to-cnd';
const DATA_SOURCE_CREATE = DATA_SOURCE + '/create';
const DATA_SOURCE_GET_BY_ID = DATA_SOURCE + '/:data_source_id';
const DATA_SOURCE_URL = DATA_SOURCE + '/:data_source_id/presigned-url';
const DATA_SOURCE_DASHBOARD_SUMMARY = DATA_SOURCE + '/dashboard-summary';
const DATA_SOURCE_LAST_RUN_DATA = DATA_SOURCE + '/last-run-data';
const DATA_SOURCE_RUN_DATA = DATA_SOURCE + '/run-data';
const DATA_SOURCE_IN_PROGRESS_RUNS = DATA_SOURCE + '/in-progress-runs';
const DATA_SOURCE_UPDATE = DATA_SOURCE + '/update';
const DATA_SOURCE_AUTO_MAP = DATA_SOURCE + '/auto-map-attribute-values';
const DATA_SOURCE_PREPROCESS_EXPORT = DATA_SOURCE + '/file/preprocessed_export';
const DATA_SOURCE_RESET_ATTRIBUTE_MAP = DATA_SOURCE + '/reset-attribute-map';
const DATA_SOURCE_COLUMN_VALUES = DATA_SOURCE + '/get-column-attribute-values';
const DATA_SOURCE_UPDATE_CONNECTED_PRODUCTS = DATA_SOURCE + '/update-connected-products';
const DATA_SOURCE_ATTRIBUTE_EXPORT = DATA_SOURCE + '/attribute_export';

const DATA_SOURCE_ORIGIN = API + '/data-source-origin';
const DATA_SOURCE_ORIGIN_ALL = DATA_SOURCE_ORIGIN + '/all';
const DATA_SOURCE_ORIGIN_CREATE = DATA_SOURCE_ORIGIN + '/create';

const DATA_SOURCE_RUN = API + '/data-source-run';
const DATA_SOURCE_RUN_URL = DATA_SOURCE_RUN + '/:data_source_run_id/presigned-url';

const DATA_SOURCE_COMMENTS = API + '/data-source-comments';
const DATA_SOURCE_COMMENTS_GET = DATA_SOURCE_COMMENTS + '/:data_source_id';
const DATA_SOURCE_COMMENTS_CREATE = DATA_SOURCE_COMMENTS;
const DATA_SOURCE_COMMENTS_UPDATE = DATA_SOURCE_COMMENTS;
const DATA_SOURCE_COMMENTS_DELETE = DATA_SOURCE_COMMENTS + '/:comment_id';

const GLOBAL_VENDOR_COMMENTS = API + '/global-vendor-comments';
const GLOBAL_VENDOR_COMMENTS_GET = GLOBAL_VENDOR_COMMENTS + '/:global_vendor_id';
const GLOBAL_VENDOR_COMMENTS_CREATE = GLOBAL_VENDOR_COMMENTS;
const GLOBAL_VENDOR_COMMENTS_UPDATE = GLOBAL_VENDOR_COMMENTS;
const GLOBAL_VENDOR_COMMENTS_DELETE = GLOBAL_VENDOR_COMMENTS + '/:comment_id';

const DATA_STREAM = API + '/data-stream';
const DATA_STREAM_GET_BY_ID = DATA_STREAM + '/:data_stream_id';
const DATA_STREAM_PROCESS = DATA_STREAM + '/process';

const DATA_STREAMS = API + '/data-streams';

const DATA_STREAM_SYNC_JOB = API + '/data-stream-sync-job';

const JOBS = API + '/jobs';
const JOB_RUNS = jobId => `${API}/jobs/${jobId}/runs`;
// runs for a job target (class_name + method), independent of the per-environment job id
const JOB_RUNS_BY_TARGET = API + '/jobs/runs';

const CUT_DRY_IMPORT_TRACKING = API + '/cut-dry-import-tracking';
const CUT_DRY_IMPORT_RUNS = CUT_DRY_IMPORT_TRACKING + '/import-runs';
const CUT_DRY_IMPORT_RUN_DETAILS = CUT_DRY_IMPORT_TRACKING + '/import-runs/:run_id';
const CUT_DRY_IMPORT_PRODUCTS = CUT_DRY_IMPORT_TRACKING + '/products';

const PRODUCT_IMAGES = API + '/product-images';
const IMAGE_RECOMMENDATIONS = PRODUCT_IMAGES + '/recommendations-for-l4';
const WEB_IMAGE_RECOMMENDATIONS = PRODUCT_IMAGES + '/web-recommendations-for-product';
const ADD_IMAGES_TO_PRODUCT = PRODUCT_IMAGES + '/add-images';
const GET_IMAGES = PRODUCT_IMAGES + '/get-assets';
const OPTIMIZE_IMAGES = PRODUCT_IMAGES + '/product-list/optimize-images';
const PRODUCT_IMAGES_DELETE_MULTI = PRODUCT_IMAGES + '/delete-multi';
const OTHER_IMAGES = PRODUCT_IMAGES + '/other-images';
const PRODUCT_IMAGES_GET_AI_SUGGESTED_PRODUCT_IMAGE_TAGS =
  PRODUCT_IMAGES + '/get-ai-suggested-product-image-tags';
const PRODUCT_IMAGES_UPDATE_AI_SUGGESTED_PRODUCT_IMAGE_TAGS =
  PRODUCT_IMAGES + '/update-ai-suggested-product-image-tags';

const NUTRITIONAL_PANELS = API + '/nutritional-panels';
const NUTRITIONAL_PANELS_UPLOAD = NUTRITIONAL_PANELS + '/upload-nutritional-panels';
const NUTRITIONAL_PANELS_FOR_VIEW = NUTRITIONAL_PANELS + '/get-nutritional-panels';
const NUTRITIONAL_PANELS_SEND_PREPROCESSED_FILE =
  NUTRITIONAL_PANELS + '/send-pre-processed-file-for-data-import';
const NUTRITIONAL_PANELS_UPLOAD_FOR_PRODUCT =
  NUTRITIONAL_PANELS + '/upload-nutritional-panels-for-product';
const NUTRITIONAL_PANELS_OF_PRODUCT = NUTRITIONAL_PANELS + '/get-panels-for-product';
const NUTRITIONAL_PANELS_SCRAPED_DETAILS_OF_PRODUCT =
  NUTRITIONAL_PANELS + '/get-scraped-nutritional-panel-values';
const NUTRITIONAL_PANELS_APPROVE_SCRAPED_DATA =
  NUTRITIONAL_PANELS + '/approve-scraped-nutritional-panel-data';
const NUTRITIONAL_PANELS_REPROCESS = NUTRITIONAL_PANELS + '/reprocess';

const PRODUCT_IMAGE = API + '/product-image';
const PRODUCT_IMAGE_MAKE_THUMBNAIL = PRODUCT_IMAGE + '/make-thumbnail';
const PRODUCT_IMAGE_TAGGING_PREDICTIONS = PRODUCT_IMAGE + '/ml/send-image-data';

const SKU_MAPPINGS = API + '/sku-mappings';
const SKU_MAPPINGS_VERIFY = SKU_MAPPINGS + '/verify-global-products';
const SKU_MAPPINGS_CANCEL = SKU_MAPPINGS + '/update-status-to-cancel';
const SKU_MAPPINGS_VERIFY_PRODUCTS = SKU_MAPPINGS + '/verify-products-in-global-product';
const SKU_MAPPINGS_UNLINK_PRODUCTS = SKU_MAPPINGS + '/unlink-products';
const SKU_MAPPINGS_UNLINK_ALL_PRODUCTS = SKU_MAPPINGS + '/unlink-all-products';
const SKU_MAPPINGS_VERIFY_LINKS = SKU_MAPPINGS + '/verify-links';
const SKU_MAPPINGS_UNVERIFY_LINKS = SKU_MAPPINGS + '/unverify-links';
const SKU_MAPPINGS_FSA_UPDATE = SKU_MAPPINGS + '/update-fsa-mappings';
const SKU_MAPPINGS_DELETE_PRODUCTS = SKU_MAPPINGS + '/delete-products';
const SKU_MAPPINGS_UNLINK_PRODUCT_GROUP = SKU_MAPPINGS + '/unlink-product-group';
const SKU_MAPPINGS_CONVERT_PRODUCTS = SKU_MAPPINGS + '/convert-to-distributor-products';
const SKU_MAPPINGS_MERGE_PRODUCTS = SKU_MAPPINGS + '/merge-manufacturer-products';
const SKU_MAPPINGS_DELETE_UNVERIFIED_MANUFACTURER_PRODUCTS =
  SKU_MAPPINGS + '/delete-unverified-manufacturer-products';
const SKU_MAPPINGS_CONVERT_MANUFACTURER_PRODUCTS_OF_PRODUCT_LIST =
  SKU_MAPPINGS + '/convert-manufacturer-products-of-product-list';
const SKU_MAPPINGS_CREATE_MANUFACTURER_PRODUCTS =
  SKU_MAPPINGS + '/create-mfr-product-from-vendor-product';
const SKU_MAPPINGS_UNARCHIVE_PRODUCTS = SKU_MAPPINGS + '/unarchive-products';

const SUPPLIER_BRAND_MANAGEMENT = API + '/supplier-brand-management';
const SUPPLIER_BRAND_MANAGEMENT_IMPORT_EXCEL = SUPPLIER_BRAND_MANAGEMENT + '/import/excel';
const SUPPLIER_BRAND_MANAGEMENT_RECORDS = SUPPLIER_BRAND_MANAGEMENT + '/records';

const AWS_BRAND_SYNC = API + '/aws-brand-sync';
const AWS_BRAND_SYNC_CREATE = AWS_BRAND_SYNC + '/create';
const AWS_BRAND_SYNC_EXECUTE = AWS_BRAND_SYNC + '/execute/:sync_id';
const AWS_BRAND_SYNC_CREATE_AND_EXECUTE = AWS_BRAND_SYNC + '/create-and-execute';
const AWS_BRAND_SYNC_DETAILS = AWS_BRAND_SYNC + '/:sync_id';
const AWS_BRAND_SYNC_DOWNLOAD_URL = AWS_BRAND_SYNC + '/:sync_id/download-url';

const AUTO_CLASSIFICATION_PRODUCT = API + '/auto-classification-product';
const AUTO_CLASSIFICATION_PRODUCT_SEND_DATA =
  AUTO_CLASSIFICATION_PRODUCT + '/send-product-data-to-ml-server';

const SUPPORT_TICKET = API + '/support-ticket';
const SUPPORT_TICKET_CREATE = SUPPORT_TICKET + '/create';
const SUPPORT_TICKET_GET_BY_ID = SUPPORT_TICKET + '/get-by-id';
const SUPPORT_TICKETS_UPDATE = SUPPORT_TICKET + '/update';
const SUPPORT_TICKET_OPEN_COUNT = SUPPORT_TICKET + '/get-count-for-side-nav-bar';
const SUPPORT_TICKET_DOWNLOAD_ATTACHMENT = SUPPORT_TICKET + '/download-attachment';

const PRODUCT_ENRICHMENT_RESOURCES = API + '/product-enrichment-resources';
const PRODUCT_ENRICHMENT_RESOURCES_RETRY_PROCESSING =
  PRODUCT_ENRICHMENT_RESOURCES + '/retry-processing';
const PRODUCT_ENRICHMENT_RESOURCES_UPDATE_QA = PRODUCT_ENRICHMENT_RESOURCES + '/update-qa-status';
const PRODUCT_ENRICHMENT_RESOURCES_UPLOAD_PRODUCT_URLS =
  PRODUCT_ENRICHMENT_RESOURCES + '/upload-product-urls';
const PRODUCT_ENRICHMENT_RESOURCES_UPLOAD_PDF = PRODUCT_ENRICHMENT_RESOURCES + '/upload-pdf';
const PRODUCT_ENRICHMENT_PDF_URLS = PRODUCT_ENRICHMENT_RESOURCES + '/pdf-urls';
const PRODUCT_ENRICHMENT_PDF_URL_BY_ID = PRODUCT_ENRICHMENT_RESOURCES + '/pdf-url';
const PRODUCT_ENRICHMENT_PDF_APPROVE = PRODUCT_ENRICHMENT_RESOURCES + '/approve-pdf';
const PRODUCT_ENRICHMENT_PDF_PRODUCT_DATA = PRODUCT_ENRICHMENT_RESOURCES + '/pdf-product-data';

const PRODUCT_LINKS_SUGGESTIONS = API + '/product-links-suggestions';
const PRODUCT_LINKS_SUGGESTIONS_SEND_DATA_TO_ML_SERVER =
  PRODUCT_LINKS_SUGGESTIONS + '/send-data-to-ml-server-to-get-product-link-suggestions';
const PRODUCT_LINKS_SUGGESTIONS_SEND_DATA_FOR_UPB_PRODUCT_MATCHING =
  PRODUCT_LINKS_SUGGESTIONS + '/send-data-to-ml-server-for-upb-product-matching';
const PRODUCT_LINKS_SUGGESTIONS_GET = PRODUCT_LINKS_SUGGESTIONS + '/get-product-link-suggestions';
const PRODUCT_LINKS_SUGGESTIONS_LINK_PRODUCTS =
  PRODUCT_LINKS_SUGGESTIONS + '/link-suggested-products-from-ml';
const PRODUCT_LINKS_SUGGESTIONS_HIDE_SUGGESTIONS = PRODUCT_LINKS_SUGGESTIONS + '/hide-suggestions';

const PRODUCT_OUTLIERS = API + '/product-outliers';
const PRODUCT_OUTLIERS_HIDE_SUGGESTIONS = PRODUCT_OUTLIERS + '/hide-suggestions';
const PRODUCT_OUTLIERS_CHANGES = PRODUCT_OUTLIERS + '/changes';
const PRODUCT_OUTLIERS_CHANGED_PRODUCTS_EXPORT = PRODUCT_OUTLIERS + '/changes-export';
const PRODUCT_OUTLIERS_QA_CHANGES = PRODUCT_OUTLIERS + '/qa-global-product-changes';
const PRODUCT_OUTLIERS_SIMILARITY_SCORES =
  PRODUCT_OUTLIERS + '/send-data-for-product-similarity-predication';
const PRODUCT_OUTLIERS_APPROVE_CHANGES = PRODUCT_OUTLIERS + '/approve-global-product-changes';
const PRODUCT_OUTLIERS_REJECT_CHANGES = PRODUCT_OUTLIERS + '/reject-global-product-changes';
const PRODUCT_OUTLIERS_FEEDBACK = PRODUCT_OUTLIERS + '/feedback';

const SCHEMA = API + '/schema';
const DELETE_SCHEMA = SCHEMA + '/:schema_id';
const SCHEMAS = API + '/schemas';

const SCHEMA_ATTRIBUTE = API + '/schema-attribute';
const ATTRIBUTE_SCHEMA_IMPORT = SCHEMA_ATTRIBUTE + '/import';

const SCHEMA_ATTRIBUTES = API + '/schema-attributes';
const SCHEMA_ATTRIBUTES_DELETE = SCHEMA_ATTRIBUTES + '/:record_ids';
const SCHEMA_ATTRIBUTES_EXPORT = SCHEMA_ATTRIBUTES + '/download-csv';

const DUPLICATE_GLOBAL_PRODUCT_SUGGESTIONS = API + '/duplicate-global-product-suggestions';
const DUPLICATE_GLOBAL_PRODUCT_SUGGESTIONS_MERGE =
  DUPLICATE_GLOBAL_PRODUCT_SUGGESTIONS + '/merge-global-products';
const DUPLICATE_GLOBAL_PRODUCT_SUGGESTIONS_DROPDOWN_DATA =
  DUPLICATE_GLOBAL_PRODUCT_SUGGESTIONS + '/dropdown-data';
const DUPLICATE_GLOBAL_PRODUCT_SUGGESTIONS_LINK_PRODUCTS =
  DUPLICATE_GLOBAL_PRODUCT_SUGGESTIONS + '/link-products';
const DUPLICATE_GLOBAL_PRODUCT_SUGGESTIONS_REJECT =
  DUPLICATE_GLOBAL_PRODUCT_SUGGESTIONS + '/reject';

const FILES = API + '/files';
const PUBLIC_UPLOAD_FILE = FILES + '/public-upload';
const UPLOAD_FILE = FILES + '/upload';
const PRESIGNED_URL = FILES + '/presigned-url';

const TOKEN_CONFIG = API + '/token-config';

const SQS = API + '/sqs';
const SQS_ATTRIBUTE_MESSAGE_COUNT = SQS + '/attributes/message-count';

const TOOLS = API + '/tools';
const GS1_XML_DECODE = TOOLS + '/gs1-xml-decode';

const ANNUALIZED_GMV = API + '/annualized-gmv';
const TOTAL_ANNUALIZED_GMV = ANNUALIZED_GMV + '/total';
const CONTRACT_TOTAL_ANNUALIZED_GMV = ANNUALIZED_GMV + '/contract-total';
const ANNUALIZED_GMV_L1 = ANNUALIZED_GMV + '/l1';
const ANNUALIZED_GMV_L1_AND_L2 = ANNUALIZED_GMV + '/l1-l2';
const UPDATE_CONTRACT_GMV = ANNUALIZED_GMV + '/update-contract-gmv';
const CONTRACT_TOTAL_ANNUALIZED_GMV_BY_VENDOR = ANNUALIZED_GMV + '/contract-total-by-vendor';
const ANNUALIZED_GMV_BY_PRODUCT_IDS = ANNUALIZED_GMV + '/by-ids';

const UPB_VIEWER_BETA = API + '/upb-viewer-beta';
const UPB_VIEWER_BETA_KPI_METRICS = UPB_VIEWER_BETA + '/kpi-metrics';
const UPB_VIEWER_BETA_ENRICHMENT_FUNNEL = UPB_VIEWER_BETA + '/enrichment-funnel';
const UPB_VIEWER_BETA_CATEGORY_GMV = UPB_VIEWER_BETA + '/category-gmv';
const UPB_VIEWER_BETA_CHILD_CATEGORY_STATS = UPB_VIEWER_BETA + '/child-category-stats';
const UPB_VIEWER_BETA_SEGMENT_ANALYSIS = UPB_VIEWER_BETA + '/segment-analysis';

const STATS = API + '/stats';
const STATS_UPB_MATCH_SUMMARY = STATS + '/upb-match/summary';
const STATS_UPB_MATCH_BAND = STATS + '/upb-match/band';
const STATS_UPB_MATCH_PARTNERS = STATS + '/upb-match/partners';
const STATS_UPB_MATCH_PARTNER = STATS + '/upb-match/partner';

const ANNUALIZED_MFR_GMV = API + '/annualized-mfr-gmv';
const ANNUALIZED_MFR_GMV_UNSTRUCTURED = ANNUALIZED_MFR_GMV + '/unstructured';
const ANNUALIZED_MFR_GMV_UNBRANDED_PRODUCT = ANNUALIZED_MFR_GMV + '/unbranded-product';
const ANNUALIZED_MFR_GMV_KPI_METRICS = ANNUALIZED_MFR_GMV + '/kpi-metrics';
const ANNUALIZED_MFR_GMV_CATEGORY_GMV = ANNUALIZED_MFR_GMV + '/category-gmv';
const ANNUALIZED_MFR_GMV_MANUFACTURERS = ANNUALIZED_MFR_GMV + '/manufacturers';
const ANNUALIZED_MFR_GMV_BRANDS = ANNUALIZED_MFR_GMV + '/brands';
const ANNUALIZED_MFR_GMV_PRODUCTS = ANNUALIZED_MFR_GMV + '/products';
const ANNUALIZED_MFR_GMV_DISTRIBUTORS = ANNUALIZED_MFR_GMV + '/distributors';
const ANNUALIZED_MFR_GMV_PRODUCT_MARKET_SHARE = ANNUALIZED_MFR_GMV + '/product-market-share';

const INTERNAL_TOOLS = API + '/internaltools';
const INTERNAL_TOOLS_DELETE_VENDOR_IMAGES = INTERNAL_TOOLS + '/images/vendor/delete';
const INTERNAL_TOOLS_DELETE_MANUFACTURER_IMAGES = INTERNAL_TOOLS + '/images/manufacturer/delete';
const INTERNAL_TOOLS_IMAGE_STATS = INTERNAL_TOOLS + '/images/stats/:entity_type/:entity_id';
const INTERNAL_TOOLS_DELETE_VENDOR_PRODUCTS = INTERNAL_TOOLS + '/products/vendor/delete';
const INTERNAL_TOOLS_DELETE_MANUFACTURER_PRODUCTS =
  INTERNAL_TOOLS + '/products/manufacturer/delete';
const INTERNAL_TOOLS_PRODUCT_STATS = INTERNAL_TOOLS + '/products/stats/:entity_type/:entity_id';
const INTERNAL_TOOLS_GET_SOURCES = INTERNAL_TOOLS + '/images/sources/:entity_type/:entity_id';
const INTERNAL_TOOLS_GENERATE_ENGAGED_MANUFACTURERS_GMV_REPORT =
  INTERNAL_TOOLS + '/reports/engaged-manufacturers-gmv';
const INTERNAL_TOOLS_GENERATE_DISTRIBUTORS_GMV_REPORT =
  INTERNAL_TOOLS + '/reports/distributors-gmv';
const INTERNAL_TOOLS_GENERATE_MANUFACTURER_ENGAGEMENT_REPORT =
  INTERNAL_TOOLS + '/reports/manufacturer-engagement';
const INTERNAL_TOOLS_GENERATE_MFR_SCORE_GAP_REPORT = INTERNAL_TOOLS + '/reports/mfr-score-gap';
const INTERNAL_TOOLS_HEALTH = INTERNAL_TOOLS + '/health';

const PRODUCT_SCORE = API + '/product-score';
const PRODUCT_SCORE_RECALCULATE = PRODUCT_SCORE + '/recalculate';
const PRODUCT_SCORE_CALCULATE_CND_SCORE = PRODUCT_SCORE + '/calculate-score-for-products';

const UNMAPPED_GMV_PRODUCTS = API + '/unmapped-gmv-products';
const UNSTRUCTURED_GMV_PRODUCTS = UNMAPPED_GMV_PRODUCTS + '/unstructured';
const UNBRANDED_GMV_PRODUCTS = UNMAPPED_GMV_PRODUCTS + '/unbranded';
const MARK_PRODUCTS_AS_NON_BRANDED = UNMAPPED_GMV_PRODUCTS + '/mark-as-non-branded';

function getURL(url, params) {
  let res = url;
  Object.keys(params).forEach(key => {
    res = res.replace(`:${key}`, params[key]);
  });
  return res;
}

function getURLWithSearchParams(url, searchParams) {
  const paramString = new URLSearchParams(searchParams).toString();
  return `${url}${paramString ? `?${paramString}` : ''}`;
}

export default SERVER;
export {
  ACTIVITY_LOGS_FIND,
  ADD_IMAGES_TO_PRODUCT,
  ADD_MANUFACTURER_THUMBNAIL_ATTRIBUTE,
  ADD_TAXONOMY_FRIENDLY_NAMES,
  ADD_VENDOR_THUMBNAIL_ATTRIBUTE,
  API_INTEGRATION,
  API_INTEGRATION_LIST,
  API_INTEGRATION_DELETE,
  ALL_ATTRIBUTES,
  ALL_PRODUCT_LISTS,
  UPB_VIEWER_BETA,
  UPB_VIEWER_BETA_CATEGORY_GMV,
  UPB_VIEWER_BETA_CHILD_CATEGORY_STATS,
  UPB_VIEWER_BETA_ENRICHMENT_FUNNEL,
  UPB_VIEWER_BETA_KPI_METRICS,
  UPB_VIEWER_BETA_SEGMENT_ANALYSIS,
  STATS_UPB_MATCH_SUMMARY,
  STATS_UPB_MATCH_BAND,
  STATS_UPB_MATCH_PARTNERS,
  STATS_UPB_MATCH_PARTNER,
  ANNUALIZED_GMV,
  TOTAL_ANNUALIZED_GMV,
  CONTRACT_TOTAL_ANNUALIZED_GMV,
  ANNUALIZED_GMV_L1,
  ANNUALIZED_GMV_L1_AND_L2,
  CONTRACT_TOTAL_ANNUALIZED_GMV_BY_VENDOR,
  ANNUALIZED_GMV_BY_PRODUCT_IDS,
  ANNUALIZED_MFR_GMV,
  ANNUALIZED_MFR_GMV_UNSTRUCTURED,
  ANNUALIZED_MFR_GMV_UNBRANDED_PRODUCT,
  ANNUALIZED_MFR_GMV_KPI_METRICS,
  ANNUALIZED_MFR_GMV_CATEGORY_GMV,
  ANNUALIZED_MFR_GMV_MANUFACTURERS,
  ANNUALIZED_MFR_GMV_BRANDS,
  UPDATE_CONTRACT_GMV,
  ATTRIBUTE_DELETE,
  ATTRIBUTE_MIGRATE_TO_GLOBAL_ATTRIBUTE,
  ATTRIBUTE_SCORE,
  ATTRIBUTE_SCORE_GROUP_BY_SECTION,
  ATTRIBUTE_SCORE_USER_INPUT_COUNTS,
  ATTRIBUTE_SCORES,
  ATTRIBUTE_SCORES_GROUP_BY_SECTION,
  ATTRIBUTE_SUB_SECTION_SCORES_UPDATE,
  ATTRIBUTE_SUB_SECTION_SCORES_GROUP_BY_SECTION,
  ATTRIBUTE_VALUE_DETAILS,
  ATTRIBUTE_VALUE_MERGE,
  ATTRIBUTE_VALUE_GROUP_MAP,
  ATTRIBUTE_VALUE_GROUP_MAPS_BY_ATTRIBUTE_ID,
  ATTRIBUTE_VALUE_GROUP_MAPS,
  ATTRIBUTE_VALUE,
  ATTRIBUTE_VALUES_BY_ATTRIBUTE_NAME,
  GET_DISPLAY_VALUE_ENABLED_RECORDS,
  ADD_DISPLAY_VALUE,
  ATTRIBUTE_VALUE_MAP,
  ATTRIBUTE_VALUE_MAPS,
  ATTRIBUTE_VALUES,
  ATTRIBUTE,
  ATTRIBUTE_MERGE,
  ATTRIBUTES_BY_CATEGORY_LEVEL,
  ATTRIBUTES_FOR_CATEGORY_LEVEL_FOR_MULTI_CATEGORIES,
  ATTRIBUTES_FOR_CATEGORY_LEVEL,
  ATTRIBUTES_ASSIGNED_CATEGORIES,
  ATTRIBUTES_FOR_DATA_SOURCE_MAPPING,
  ATTRIBUTES_FOR_PRODUCT_UPDATE,
  ATTRIBUTES_FOR_PRODUCT_UPDATE_MULTI,
  ATTRIBUTES_FOR_PRODUCT,
  ATTRIBUTES_MAP_DETAILS,
  ATTRIBUTES_MAP,
  ATTRIBUTES_MAPS_DETAILS,
  ATTRIBUTES_MAPS,
  ATTRIBUTES_MAPS_CREATE,
  ATTRIBUTES_MAPS_MULTI_CREATE,
  ATTRIBUTES_SECTION,
  ATTRIBUTES_SECTIONS,
  ATTRIBUTES_SUB_SECTION_ALL,
  ATTRIBUTES_SUB_SECTIONS_WITH_SECTIONS,
  ATTRIBUTES_SUB_SECTIONS_FOR_A_SECTION,
  ATTRIBUTES_SUB_SECTIONS_FOR_SECTION,
  ATTRIBUTES,
  ATTRIBUTION_COMPLIANCE_CSV_EXPORT,
  ATTRIBUTES_COUNT_BY_SECTION,
  ATTRIBUTE_CSV_IMPORT_FOR_ROSETTA_TAXONOMIES,
  AUTO_CLASSIFICATION_PRODUCT_SEND_DATA,
  BRANDS_ACTIVITY_LOG,
  BRANDS_FOR_HARVEST,
  BRANDS_FOR_QA,
  BRANDS_UPDATE_FROM_QA,
  BRANDS_FOR_HARVEST_GROUPED,
  BRANDS_HARVEST,
  BRANDS_BY_IDS,
  BRANDS_CREATE,
  BRANDS_DELETE,
  BRANDS_DELETE_LOGO,
  BRANDS_DELETE_SIMILAR_BRAND_NAMES,
  BRANDS_DELETE_UNLINKED,
  BRANDS_DOWNLOAD_CSV,
  BRANDS_FOR_DROPDOWN,
  BRANDS_GET_BY_ID,
  BRANDS_GET_BY_NAME,
  BRANDS_GET_BY_MANUFACTURER,
  BRANDS_GENERATE_ACTIVITY_REPORT,
  BRANDS_IMPORT,
  BRANDS_MERGE,
  BRANDS_PRODUCTS,
  BRAND_PRODUCT_OUTLIER_CLEANUP_STATS,
  BRANDS_DP_PRODUCTS,
  BRAND_CATEGORY_FILTER_OPTIONS,
  FOR_CONTENT_QA,
  BRANDS_UNVERIFY,
  BRANDS_UPDATE,
  BRANDS_UPDATE_MULTI,
  BRANDS_UPDATE_FROM_FSA,
  BRANDS,
  BRAND,
  BRAND_HARVEST,
  SIMILAR_BRAND_INFO,
  SIMILAR_BRAND_UPDATE,
  GET_SIMILAR_BRAND_NAME_INFO,
  UPDATE_SIMILAR_BRAND,
  UPDATE_SIMILAR_BRAND_DISPLAY_STATUS,
  CATALOG_FILTER_ATTRIBUTES_VENDOR,
  CATALOG_FILTER_ATTRIBUTES_VENDOR_CREATE,
  CATALOG_FILTER_ATTRIBUTES_VENDOR_UPDATE,
  CATALOG_FILTER_ATTRIBUTES_VENDOR_DELETE,
  CATALOG_FILTER_ATTRIBUTES_VENDOR_CREATE_PRESET,
  CATALOG_FILTER_PRESETS_FOR_DROPDOWN,
  CATALOG_FILTER_PRESET,
  CHANGE_LOG_GROUP,
  CHANGE_LOGS_BY_IDS,
  CHANGE_LOGS_BY_REQUEST_ID,
  CHANGE_LOGS_BY_STATUS,
  CHANGE_LOGS_DELETED_IMAGE_DETAILS,
  CHANGE_LOGS_FOR_GLOBAL_PRODUCT,
  CHANGE_LOGS_LATEST_RECORD,
  CHANGE_LOGS_UPDATE_STATUS,
  CHANGE_LOGS,
  CLEAN_INVALID_PRODUCTS,
  CURRENT_USER,
  CURRENT_USER_PING,
  DASHBOARD,
  DATA_SOURCE_ALL,
  DATA_SOURCE_ASSIGN_SKUS,
  DATA_SOURCE_COLUMN_VALUES,
  DATA_SOURCE_CONNECTED_MANUFACTURERS,
  DATA_SOURCE_CONNECTED_PRODUCTS,
  DATA_SOURCE_CREATE,
  DATA_SOURCE_DASHBOARD_SUMMARY,
  DATA_SOURCE_EXPORT_GDSN_MANUFACTURER_PRODUCTS,
  DATA_SOURCE_SEND_GDSN_MANUFACTURER_PRODUCTS_TO_CND,
  DATA_SOURCE_GET_BY_ID,
  DATA_SOURCE_LAST_RUN_DATA,
  DATA_SOURCE_ORIGIN_ALL,
  DATA_SOURCE_ORIGIN_CREATE,
  DATA_SOURCE_PROCESS,
  DATA_SOURCE_PREPROCESS_EXPORT,
  DATA_SOURCE_RUN_DATA,
  DATA_SOURCE_IN_PROGRESS_RUNS,
  DATA_SOURCE_RUN_URL,
  DATA_SOURCE_RESET_ATTRIBUTE_MAP,
  DATA_SOURCE_UPDATE_CONNECTED_PRODUCTS,
  DATA_STREAM,
  DATA_STREAM_GET_BY_ID,
  DATA_STREAM_PROCESS,
  DATA_STREAMS,
  DATA_STREAM_SYNC_JOB,
  JOBS,
  JOB_RUNS,
  JOB_RUNS_BY_TARGET,
  CUT_DRY_IMPORT_TRACKING,
  CUT_DRY_IMPORT_RUNS,
  CUT_DRY_IMPORT_RUN_DETAILS,
  CUT_DRY_IMPORT_PRODUCTS,
  DELETE_TASK,
  KILL_TASK,
  EXECUTE_TASK,
  DATA_SOURCE_ARCHIVE,
  DATA_SOURCE_CLONE,
  DATA_SOURCE_ATTRIBUTE_EXPORT,
  DATA_SOURCE_UPDATE,
  DATA_SOURCE_COMMENTS,
  DATA_SOURCE_COMMENTS_GET,
  DATA_SOURCE_COMMENTS_CREATE,
  DATA_SOURCE_COMMENTS_UPDATE,
  DATA_SOURCE_COMMENTS_DELETE,
  GLOBAL_VENDOR_COMMENTS,
  GLOBAL_VENDOR_COMMENTS_GET,
  GLOBAL_VENDOR_COMMENTS_CREATE,
  GLOBAL_VENDOR_COMMENTS_UPDATE,
  GLOBAL_VENDOR_COMMENTS_DELETE,
  DATA_SOURCE_AUTO_MAP,
  DATA_SOURCE_URL,
  DUPLICATE_GLOBAL_PRODUCT_SUGGESTIONS,
  DUPLICATE_GLOBAL_PRODUCT_SUGGESTIONS_MERGE,
  DUPLICATE_GLOBAL_PRODUCT_SUGGESTIONS_DROPDOWN_DATA,
  DUPLICATE_GLOBAL_PRODUCT_SUGGESTIONS_LINK_PRODUCTS,
  DUPLICATE_GLOBAL_PRODUCT_SUGGESTIONS_REJECT,
  EXPORT_ATTRIBUTES,
  IMPORT_ATTRIBUTES,
  UPDATE_ATTRIBUTES_BY_ATTRIBUTE_ID,
  IMPORT_ATTRIBUTE_VALUES,
  DELETE_ORPHANED_GLOBAL_PRODUCTS,
  EXPORT_DATA_CUT_DRY,
  EXPORT_HILLCREST_ERRORS,
  EXPORT_INCORRECTLY_LINKED_PRODUCTS_LIST,
  EXPORT_P0_CD,
  EXPORT_PRODUCTS_CD,
  FILE_EXPORTS,
  FILE_EXPORT_PRESIGNED_URL,
  FILE_EXPORTS_GENERATE_REPORTS,
  FILE_EXPORTS_MANUFACTURER_SKU_CLEAN_UP_REPORT,
  FILE_EXPORTS_ENGAGED_MANUFACTURER_SCORES_EXPORT,
  FILE_EXPORTS_MANUFACTURERS_GLN_STATUS_ASSOCIATED_WITH_A_VENDOR,
  FILE_EXPORTS_PRODUCT_DATA_WITH_GMV_AND_MAPPING,
  FILE_EXPORTS_MASTER_LOCATION_PRODUCT_DETAILS,
  FILE_EXPORTS_UNMAPPED_GMV_PRODUCTS,
  FILE_EXPORTS_UNSTRUCTURED_GMV_PRODUCTS,
  REBATE_ANALYSIS_CSV_UPLOAD,
  REBATE_ANALYSIS_UPLOADS,
  REBATE_ANALYSIS_UPLOAD,
  REBATE_ANALYSIS_UPLOAD_PRESIGNED_URL,
  REBATE_ANALYSIS_UPLOAD_CONTENT,
  REBATE_ANALYSIS_RUN_ANALYSIS,
  REBATE_ANALYSIS_UPLOAD_FILE,
  DEVIATED_PRICE_ANALYSIS_UPLOADS,
  DEVIATED_PRICE_ANALYSIS_UPLOAD,
  DEVIATED_PRICE_ANALYSIS_GENERATE_REPORT,
  DEVIATED_PRICE_ANALYSIS_UPLOAD_FILE,
  FIX_INVALID_GLOBAL_PRODUCT_NAMES,
  FIX_MANUFACTURER_DATA,
  FIX_VENDOR_DATA,
  GET_IMAGES,
  OPTIMIZE_IMAGES,
  getURL,
  getURLWithSearchParams,
  GLOBAL_ATTRIBUTE_DETAILS,
  GLOBAL_ATTRIBUTE_DELETE,
  GLOBAL_ATTRIBUTE,
  GLOBAL_ATTRIBUTES_FOR_SECTION,
  GLOBAL_ATTRIBUTES,
  GLOBAL_ATTRIBUTE_MIGRATE_TO_ATTRIBUTE,
  GLOBAL_MANUFACTURERS_ACTIVITY_LOG,
  GLOBAL_MANUFACTURERS_ASSIGN_THUMBNAILS,
  GLOBAL_MANUFACTURERS_BROKEN_IMAGE_DELETE,
  GLOBAL_MANUFACTURERS_CONVERT_TO_DISTRIBUTOR,
  GLOBAL_MANUFACTURERS_DELETE_SIMILAR_MANUFACTURERS_NAMES,
  GLOBAL_MANUFACTURERS_DELETE_UNLINKED,
  GLOBAL_MANUFACTURERS_DOWNLOAD_CSV,
  GLOBAL_MANUFACTURERS_EXPORT_BRAND_PRODUCTS,
  GLOBAL_MANUFACTURERS_FOR_DROPDOWN,
  GLOBAL_MANUFACTURERS_GDSN_SUBSCRIPTION,
  GLOBAL_MANUFACTURERS_GET_BY_ID,
  GLOBAL_MANUFACTURERS_BY_IDS,
  GLOBAL_MANUFACTURERS_MERGE,
  GLOBAL_MANUFACTURERS_PRODUCTS,
  GLOBAL_MANUFACTURERS_UNVERIFY,
  GLOBAL_MANUFACTURERS_UPDATE,
  GLOBAL_MANUFACTURERS_UPDATE_FROM_FSA,
  GLOBAL_MANUFACTURERS,
  GLOBAL_MANUFACTURERS_CREATE,
  GLOBAL_MANUFACTURER,
  GLOBAL_MANUFACTURER_CREATE_CUT_DRY_PORTAL,
  GLOBAL_MANUFACTURER_CREATE_PRODUCTS,
  GLOBAL_MANUFACTURER_PRODUCT_CREATION,
  GLOBAL_MANUFACTURER_UPB_SKU,
  CLIENT_GLOBAL_MANUFACTURER,
  GLOBAL_MANUFACTURERS_HARVEST,
  GLOBAL_MANUFACTURER_HARVEST_STATUS,
  GLOBAL_MANUFACTURER_HARVEST_TAGS,
  GLOBAL_MANUFACTURER_HARVEST_TAGS_BY_MANUFACTURER,
  GLOBAL_MANUFACTURER_HARVEST_STATISTICS,
  GLOBAL_MANUFACTURER_HARVEST_EXPORT,
  GLOBAL_PRODUCT_MERGE_DUPLICATES,
  GLOBAL_PRODUCT_REMOVE_CATEGORIES,
  GLOBAL_PRODUCT,
  GLOBAL_PRODUCT_PDP,
  GLOBAL_PRODUCT_RESET_CACHE,
  GLOBAL_PRODUCT_DEFAULT_IMAGE_UPDATE,
  GLOBAL_PRODUCT_ID_UPDATE,
  GLOBAL_PRODUCTS_BY_IDS,
  GLOBAL_PRODUCTS_BY_SEARCH,
  GLOBAL_PRODUCT_SUMMARY,
  GLOBAL_PRODUCT_SALES_PRICING,
  GLOBAL_PRODUCT_DISTRIBUTORS,
  GLOBAL_PRODUCTS_DOWNLOAD_CSV,
  GLOBAL_PRODUCTS_MARK_SPECIALLY_UPLOADED,
  GLOBAL_PRODUCTS_UPDATE_CATEGORIES,
  GLOBAL_PRODUCTS,
  GLOBAL_PRODUCT_VENDOR_CLONE,
  GLOBAL_PRODUCT_VENDOR_CLONE_IMAGES,
  GLOBAL_PRODUCT_VENDOR_GET_PRODUCTS,
  TEMPORARY_PRODUCT_IMAGE_GET_PRODUCTS,
  TEMPORARY_PRODUCT_IMAGE_UPDATE_TEMP_IMAGE,
  TEMPORARY_PRODUCT_IMAGE_THUMBNAIL_ASSIGNING_STATS,
  TEMPORARY_PRODUCT_IMAGE_PREPARE_PRODUCT_LIST_FOR_THUMBNAIL_ASSIGNING,
  TEMPORARY_PRODUCT_IMAGE_SEND_DATA_TO_ML_SERVER_TO_GET_THUMBNAIL_SUGGESTIONS,
  SEND_DATA_TO_ML_SERVER_TO_NORMALIZE_DP_BRANDS,
  SEND_DATA_TO_ML_SERVER_TO_EXTRACT_BRANDS,
  GLOBAL_PRODUCT_VENDOR_MARK_AS_DEMO,
  GLOBAL_PRODUCT_VENDOR_MANUFACTURER_PRODUCT_LINK_SUGGESTIONS,
  GLOBAL_PRODUCT_VENDOR_LINK_SUGGESTIONS,
  GLOBAL_VENDOR_MANUFACTURER_PORTAL_CREATE,
  GLOBAL_VENDOR_MANUFACTURER_PORTAL_CREATE_REQUEST,
  GLOBAL_VENDOR_MANUFACTURER_PORTAL_PRODUCT_EXPORT,
  GLOBAL_VENDOR_MANUFACTURER_PORTAL_REQUESTS,
  GLOBAL_VENDOR_MANUFACTURER_PRODUCT_CREATION,
  GLOBAL_VENDOR_THIRD_PARTY_OPTIONS,
  GLOBAL_VENDOR_SNOWFLAKE_STATS,
  CLIENT_GLOBAL_VENDOR,
  GLOBAL_VENDOR_BRAND_COVERAGE,
  GLOBAL_VENDOR_UPDATE_FLAGS,
  GLOBAL_VENDOR_UPDATE_ATTRIBUTE_PROPAGATION_FLAG,
  GLOBAL_VENDORS_ASSIGN_THUMBNAILS,
  GLOBAL_VENDOR_ATTRIBUTE_REQUIREMENTS_FOR_ATTRIBUTE,
  GLOBAL_VENDOR_ATTRIBUTE_REQUIREMENTS,
  GLOBAL_VENDORS_BROKEN_IMAGE_DELETE,
  GLOBAL_VENDORS_BY_IDS,
  GLOBAL_VENDORS,
  GLOBAL_VENDORS_CREATE,
  GLOBAL_VENDORS_CREATE_DEMO_CATALOG,
  GLOBAL_VENDORS_DOWNLOAD_CSV,
  GLOBAL_VENDORS_DOWNLOAD_STATS_CSV,
  GLOBAL_VENDORS_CHAIN_LOCATIONS,
  GLOBAL_VENDORS_FOR_DROPDOWN,
  GLOBAL_VENDORS_UPDATE,
  GLOBAL_VENDORS_GET_BY_ID,
  GS1_XML_DECODE,
  GTIN_GS1,
  HILLCREST_PRODUCT_RESTORE,
  FSA_SKU_MAPPINGS_EXPORT,
  IMAGE_RECOMMENDATIONS,
  GTIN_VALIDATOR_CSV,
  isLocalhost,
  isStagingServer,
  isSandboxServer,
  isCharliesProduceServer,
  isClientTestServer,
  LOGIN,
  LOGOUT,
  NUTRITIONAL_PANELS,
  NUTRITIONAL_PANELS_APPROVE_SCRAPED_DATA,
  NUTRITIONAL_PANELS_FOR_VIEW,
  NUTRITIONAL_PANELS_OF_PRODUCT,
  NUTRITIONAL_PANELS_REPROCESS,
  NUTRITIONAL_PANELS_SCRAPED_DETAILS_OF_PRODUCT,
  NUTRITIONAL_PANELS_SEND_PREPROCESSED_FILE,
  NUTRITIONAL_PANELS_UPLOAD,
  NUTRITIONAL_PANELS_UPLOAD_FOR_PRODUCT,
  OTHER_IMAGES,
  PRODUCT_IMAGES_GET_AI_SUGGESTED_PRODUCT_IMAGE_TAGS,
  PRODUCT_IMAGES_UPDATE_AI_SUGGESTED_PRODUCT_IMAGE_TAGS,
  PRODUCT_ENRICHMENT_RESOURCES,
  PRODUCT_ENRICHMENT_RESOURCES_RETRY_PROCESSING,
  PRODUCT_ENRICHMENT_RESOURCES_UPDATE_QA,
  PRODUCT_ENRICHMENT_RESOURCES_UPLOAD_PRODUCT_URLS,
  PRODUCT_ENRICHMENT_RESOURCES_UPLOAD_PDF,
  PRODUCT_ENRICHMENT_PDF_PRODUCT_DATA,
  PRODUCT_ENRICHMENT_PDF_URLS,
  PRODUCT_ENRICHMENT_PDF_URL_BY_ID,
  PRODUCT_ENRICHMENT_PDF_APPROVE,
  PRODUCT_IMAGE,
  PRODUCT_IMAGES,
  PRODUCT_IMAGES_DELETE_MULTI,
  PRODUCT_IMAGE_MAKE_THUMBNAIL,
  PRODUCT_IMAGE_TAGGING_PREDICTIONS,
  PRODUCT_LIST_ID,
  PRODUCT_LIST_PRODUCTS,
  PRODUCT_LIST,
  PRODUCT_LISTS,
  PRODUCT_LIST_ASSIGN_THUMBNAILS,
  PRODUCT_LIST_ATTRIBUTION_CSV_EXPORT,
  PRODUCT_LIST_ATTRIBUTION_EXPORT,
  PRODUCT_LIST_BROKEN_IMAGE_DELETE,
  PRODUCT_LIST_PRODUCT_SCORE,
  PRODUCT_LIST_PRODUCT_P0_SCORE,
  PRODUCT_LIST_FOR_DROPDOWNS,
  PRODUCT_LIST_UNASSIGNED_ATTRIBUTES,
  CATALOG_IMPORT_WORKFLOW,
  CATALOG_IMPORT_WORKFLOW_STEPS,
  CATALOG_IMPORT_WORKFLOW_INITIALIZE,
  CATALOG_IMPORT_WORKFLOW_START,
  CATALOG_IMPORT_WORKFLOW_STATUS,
  CATALOG_IMPORT_WORKFLOW_RESET,
  CATALOG_IMPORT_WORKFLOW_MARK_COMPLETE,
  CATALOG_IMPORT_WORKFLOW_RETRY_STEP,
  PRODUCT_LIST_IMAGE_CLEANUP,
  PRODUCT_LIST_IMAGE_FOR_TAGGING,
  PRODUCT_LIST_PRODUCTS_COVERAGE_METRICS,
  PRODUCT_LIST_IMAGE_SOURCE_EXPORT,
  PRODUCT_LIST_MANUFACTURER_PRODUCT_ENRICHMENT_EXPORT,
  PRODUCT_LIST_STATUS_UPDATE_ON_PRODUCTS,
  PRODUCT_LIST_REFRESH_CACHE,
  PRODUCT_LIST_UPB_MATCH_CSV_EXPORT,
  PRODUCT_LIST_UPDATE_PRODUCTS,
  PRODUCT_LIST_VENDOR_CATEGORIES,
  PRODUCT_OUTLIERS,
  PRODUCT_OUTLIERS_APPROVE_CHANGES,
  PRODUCT_OUTLIERS_CHANGES,
  PRODUCT_OUTLIERS_CHANGED_PRODUCTS_EXPORT,
  PRODUCT_OUTLIERS_FEEDBACK,
  PRODUCT_OUTLIERS_HIDE_SUGGESTIONS,
  PRODUCT_OUTLIERS_QA_CHANGES,
  PRODUCT_OUTLIERS_REJECT_CHANGES,
  PRODUCT_OUTLIERS_SIMILARITY_SCORES,
  PRODUCTS_BY_GLOBAL_PRODUCT_IDS,
  GLOBAL_PRODUCTS_WITHOUT_DEFAULT_IMAGES,
  PUBLIC_UPLOAD_FILE,
  PRESIGNED_URL,
  RESET_PRODUCT_THUMBNAILS,
  ROLE,
  ROLES,
  SEPARATE_HILLCREST_PRODUCTS,
  SKU_MAPPINGS_CANCEL,
  SKU_MAPPINGS_CONVERT_MANUFACTURER_PRODUCTS_OF_PRODUCT_LIST,
  SKU_MAPPINGS_CONVERT_PRODUCTS,
  SKU_MAPPINGS_CREATE_MANUFACTURER_PRODUCTS,
  SUPPLIER_BRAND_MANAGEMENT,
  SUPPLIER_BRAND_MANAGEMENT_IMPORT_EXCEL,
  SUPPLIER_BRAND_MANAGEMENT_RECORDS,
  AWS_BRAND_SYNC,
  AWS_BRAND_SYNC_CREATE,
  AWS_BRAND_SYNC_EXECUTE,
  AWS_BRAND_SYNC_CREATE_AND_EXECUTE,
  AWS_BRAND_SYNC_DETAILS,
  AWS_BRAND_SYNC_DOWNLOAD_URL,
  SUPPORT_TICKET,
  SUPPORT_TICKET_CREATE,
  SUPPORT_TICKET_GET_BY_ID,
  SUPPORT_TICKETS_UPDATE,
  SUPPORT_TICKET_OPEN_COUNT,
  SUPPORT_TICKET_DOWNLOAD_ATTACHMENT,
  PRODUCT_LINKS_SUGGESTIONS_SEND_DATA_TO_ML_SERVER,
  PRODUCT_LINKS_SUGGESTIONS_SEND_DATA_FOR_UPB_PRODUCT_MATCHING,
  PRODUCT_LINKS_SUGGESTIONS_GET,
  PRODUCT_LINKS_SUGGESTIONS_LINK_PRODUCTS,
  PRODUCT_LINKS_SUGGESTIONS_HIDE_SUGGESTIONS,
  SKU_MAPPINGS_DELETE_PRODUCTS,
  SKU_MAPPINGS_DELETE_UNVERIFIED_MANUFACTURER_PRODUCTS,
  SKU_MAPPINGS_FSA_UPDATE,
  SKU_MAPPINGS_MERGE_PRODUCTS,
  SKU_MAPPINGS_UNARCHIVE_PRODUCTS,
  SKU_MAPPINGS_UNLINK_ALL_PRODUCTS,
  SKU_MAPPINGS_UNLINK_PRODUCTS,
  SKU_MAPPINGS_UNLINK_PRODUCT_GROUP,
  SKU_MAPPINGS_UNVERIFY_LINKS,
  SKU_MAPPINGS_VERIFY_LINKS,
  SKU_MAPPINGS_VERIFY_PRODUCTS,
  SKU_MAPPINGS_VERIFY,
  SKU_MAPPINGS,
  TAXONOMY,
  TAXONOMY_CATEGORY_DETAILS,
  TAXONOMY_CHILD_CATEGORY_DETAILS,
  TAXONOMY_CATEGORY_LEVEL_OPTIONS,
  TAXONOMY_CATEGORY_LEVEL_OPTIONS_WITH_SUB_OPTIONS,
  TAXONOMY_CATEGORY_NAMES,
  TAXONOMY_CATEGORY_OPTIONS,
  TAXONOMY_CATEGORY_OPTIONS_FOR_PRODUCT_LIST,
  TAXONOMY_CREATE_CATEGORY,
  L4_CATEGORY_DIVISION,
  L4_CATEGORY_DIVISION_AVAILABLE_CATEGORIES,
  L4_CATEGORY_DIVISION_ATTRIBUTE_SUMMARY,
  L4_CATEGORY_DIVISION_LARGE_CATEGORIES,
  L4_CATEGORY_DIVISION_EXPORT_LARGE_CATEGORIES,
  L4_CATEGORY_DIVISION_EXPORT_CATEGORY_PRODUCTS,
  L4_CATEGORY_DIVISION_EXPORT_RESEGMENTATION_VIEW,
  L4_CATEGORY_DIVISION_EXPORT_RESEGMENTATION_ERROR_REPORT,
  L4_CATEGORY_DIVISION_EXPORT_SEGMENTATION_VIEW,
  L4_CATEGORY_DIVISION_PRODUCTS_BY_ATTRIBUTE,
  L4_CATEGORY_DIVISION_RESEGMENT_BY_ATTRIBUTE,
  L4_CATEGORY_DIVISION_RESEGMENTED_CATEGORIES,
  L4_CATEGORY_DIVISION_RESEGMENTED_CLASSIFICATION_OPTIONS,
  L4_CATEGORY_DIVISION_RESEGMENTED_CLASSIFY,
  L4_CATEGORY_DIVISION_RESEGMENTED_CLUSTER_NAMES,
  L4_CATEGORY_DIVISION_RESEGMENTED_FILTER_OPTIONS,
  L4_CATEGORY_DIVISION_RESEGMENTED_BULK_MOVE_CLUSTER,
  L4_CATEGORY_DIVISION_RESEGMENTED_BULK_REMOVE,
  L4_CATEGORY_DIVISION_RESEGMENTED_RENAME_CLUSTER,
  L4_CATEGORY_DIVISION_RESEGMENTED_MOVE_CLUSTER,
  L4_CATEGORY_DIVISION_RESEGMENTED_PRODUCTS,
  L4_CATEGORY_DIVISION_RESEGMENTED_REMOVE_PRODUCT,
  L4_CATEGORY_DIVISION_RETRY_SEGMENTATION,
  L4_CATEGORY_DIVISION_SEND_PRODUCTS,
  TAXONOMY_DELETE_CATEGORY,
  TAXONOMY_EDIT_CATEGORY_NAME,
  TAXONOMY_EXPORT,
  TAXONOMY_GET,
  TAXONOMY_L3_DEFAULT_IMAGE,
  TAXONOMY_L4_DEFAULT_IMAGE,
  TAXONOMY_SET_L3_DEFAULT_IMAGE,
  TAXONOMY_SET_L4_DEFAULT_IMAGE,
  TAXONOMY_SET_L3_DEFAULT_IMAGE_NOT_APPLICABLE,
  TAXONOMY_SET_L4_DEFAULT_IMAGE_NOT_APPLICABLE,
  TAXONOMY_GET_L4_CATEGORIES_BY_IMAGE_UPLOAD_STATUS,
  TAXONOMY_GET_L3_CATEGORIES_BY_L4_IMAGE_UPLOAD_STATUS,
  TAXONOMY_GET_REJECTED_L4_IMAGES_BY_USER_ID,
  TAXONOMY_REVIEW_L4_DEFAULT_IMAGES,
  TAXONOMY_UPB_VIEW_CATEGORY_OPTIONS,
  TAXONOMY_UPPER_LEVELS,
  TOKEN_CONFIG,
  UPDATE_MANUFACTURER_PRODUCT_SCORES,
  UPDATE_SYSCO_STATUSES,
  UPDATE_USER_ROLES,
  UPDATE_VENDOR_PRODUCT_SCORES,
  UPLOAD_FILE,
  USERS,
  USERS_GET_FOR_DROPDOWN,
  USER_TIME_LOG,
  USER_TIME_LOG_GET_LOGS,
  USER_TIME_LOG_CREATE,
  USER_TIME_LOG_DELETE,
  USER_TIME_LOG_SET_CONFIGURATIONS,
  USER_TIME_LOG_GET_CONFIGURATIONS,
  USERS_OF_REJECTED_DEFAULT_L4_IMAGES,
  UPDATE_PRODUCT_BRANDS,
  BRAND_CLEANUP_PRODUCTS_EXPORT,
  GET_FOR_BRAND_CLEANUP,
  GET_BRANDS_FOR_BRAND_CLEANUP,
  GET_L4_CATEGORIES_FOR_SELECTED_VENDOR_AND_BRAND,
  GET_CATEGORIES_FOR_BRAND_CLEANUP,
  CLEANUP_BRANDS_OF_SELECTED_PRODUCTS,
  GET_SUGGESTED_BRANDS_FOR_BRAND_CLEANUP,
  GET_DISTRIBUTOR_BRAND_NAMES_FOR_BRAND_CLEANUP,
  DUPLICATE_BRANDS_GET_DUPLICATE_BRAND_CLUSTERS,
  DUPLICATE_BRANDS_HANDLE_DUPLICATE_BRAND_CLUSTERS,
  DUPLICATE_UNVERIFIED_BRANDS_GET_DUPLICATE_UNVERIFIED_BRAND_CLUSTERS,
  DUPLICATE_UNVERIFIED_BRANDS_HANDLE_DUPLICATE_BRAND_CLUSTERS,
  GET_ONE_BRAND_VERIFICATION_SUGGESTION,
  UPDATE_VERIFICATION_STATUS_FROM_SUGGESTION,
  UPDATE_BRAND_AND_MANUFACTURER_DATA_FROM_BRAND_VERIFICATION_TOOL,
  UPDATE_BRAND_VERIFICATION_SUGGESTION,
  BRAND_VERIFICATION_SUGGESTIONS_GET_STATS,
  VIEWS,
  WEB_IMAGE_RECOMMENDATIONS,
  TASKS,
  TASKS_COUNT_BY_STATUS,
  TASKS_ANALYZE_P0_SYNC_GAPS,
  SQS_ATTRIBUTE_MESSAGE_COUNT,
  SCHEMA,
  DELETE_SCHEMA,
  SCHEMAS,
  SCHEMA_ATTRIBUTE,
  ATTRIBUTE_SCHEMA_IMPORT,
  SCHEMA_ATTRIBUTES,
  SCHEMA_ATTRIBUTES_DELETE,
  SCHEMA_ATTRIBUTES_EXPORT,
  GLOBAL_PRODUCT_MANUFACTURER,
  GLOBAL_PRODUCT_MANUFACTURER_CREATE,
  GLOBAL_PRODUCT_MANUFACTURER_PDP,
  GLOBAL_PRODUCT_MANUFACTURER_UPDATE,
  GLOBAL_PRODUCT_MANUFACTURERS,
  GLOBAL_PRODUCT_MANUFACTURERS_BY_SEARCH,
  OPEN_SEARCH_INDEX_MFR_PRODUCT_SEARCH,
  GLOBAL_PRODUCT_MANUFACTURERS_L1_CATEGRIES,
  USER_CREATE,
  USER_GET_ALL_NOTIFICATIONS,
  isProd,
  PRODUCT_SCORE,
  PRODUCT_SCORE_RECALCULATE,
  PRODUCT_SCORE_CALCULATE_CND_SCORE,
  GLOBAL_PRODUCT_REJECTED_GTINS,
  SKU_MAPPING_WORKFLOW,
  SKU_MAPPING_WORKFLOW_RETRY,
  BRAND_SKU_MAPPER,
  BRAND_SKU_MAPPER_MANUFACTURERS,
  BRAND_SKU_MAPPER_MANUFACTURER,
  BRAND_SKU_MAPPER_START_RUN,
  BRAND_SKU_MAPPER_PRODUCTS,
  BRAND_SKU_MAPPER_REVIEW_CANDIDATE,
  BRAND_SKU_MAPPER_ALL_BRANDS_START,
  BRAND_SKU_MAPPER_AUTO_APPROVE_GTIN,
  BRAND_SKU_MAPPER_V2,
  BRAND_SKU_MAPPER_V2_START_RUN,
  BRAND_SKU_MAPPER_V2_ELIGIBLE_COUNTS,
  BRAND_SKU_MAPPER_V2_FILTER_OPTIONS,
  BRAND_SKU_MAPPER_V2_PRODUCTS,
  BRAND_SKU_MAPPER_V2_PRODUCT_CANDIDATES,
  BRAND_SKU_MAPPER_V2_REVIEW_CANDIDATE,
  CLIENT_DISTRIBUTOR_PRODUCT,
  CLIENT_DISTRIBUTOR_PRODUCT_NATIONAL_SKU,
  CLIENT_DISTRIBUTOR_PRODUCT_ATTRIBUTE_PROPAGATION_FLAG,
  CLIENT_MANUFACTURER_PRODUCT,
  CLIENT_MANUFACTURER_PRODUCT_UNIPRO_UPB_ELIGIBLE,
  SKU_MAPPING_WORKFLOW_SIMILARITY_THRESHOLD,
  ANNUALIZED_MFR_GMV_PRODUCTS,
  ANNUALIZED_MFR_GMV_DISTRIBUTORS,
  ANNUALIZED_MFR_GMV_PRODUCT_MARKET_SHARE,
  INTERNAL_TOOLS,
  INTERNAL_TOOLS_DELETE_VENDOR_IMAGES,
  INTERNAL_TOOLS_DELETE_MANUFACTURER_IMAGES,
  INTERNAL_TOOLS_IMAGE_STATS,
  INTERNAL_TOOLS_DELETE_VENDOR_PRODUCTS,
  INTERNAL_TOOLS_DELETE_MANUFACTURER_PRODUCTS,
  INTERNAL_TOOLS_PRODUCT_STATS,
  INTERNAL_TOOLS_GET_SOURCES,
  INTERNAL_TOOLS_GENERATE_ENGAGED_MANUFACTURERS_GMV_REPORT,
  INTERNAL_TOOLS_GENERATE_DISTRIBUTORS_GMV_REPORT,
  INTERNAL_TOOLS_GENERATE_MANUFACTURER_ENGAGEMENT_REPORT,
  INTERNAL_TOOLS_GENERATE_MFR_SCORE_GAP_REPORT,
  INTERNAL_TOOLS_HEALTH,
  UNMAPPED_GMV_PRODUCTS,
  UNSTRUCTURED_GMV_PRODUCTS,
  UNBRANDED_GMV_PRODUCTS,
  MARK_PRODUCTS_AS_NON_BRANDED,
};
